(function () {
   /** Versionamento no rodapé: ds-version.json (última alteração em qualquer arquivo do DS). */
   function formatDsVersionDate(date) {
      var day = date.getDate();
      var month = date.getMonth() + 1;
      var year = date.getFullYear();
      return (day < 10 ? '0' : '') + day + '/' + (month < 10 ? '0' : '') + month + '/' + year;
   }

   function getDsRevisionDateFromMeta() {
      var meta = document.querySelector('meta[name="ds-last-modified"]');
      if (meta && meta.content) {
         var fromMeta = new Date(meta.content);
         if (!isNaN(fromMeta.getTime())) return fromMeta;
      }
      return new Date(document.lastModified);
   }

   function applyVersionTooltip(modified) {
      var trigger = document.querySelector('[data-ds-version-trigger]');
      var tooltip = document.getElementById('ds-version-tooltip');
      if (!trigger || !tooltip) return;
      if (!modified || isNaN(modified.getTime())) return;

      var label = 'Última edição: ' + formatDsVersionDate(modified);
      tooltip.textContent = label;
      trigger.setAttribute('aria-label', 'Documentação versão 1.0. ' + label);
   }

   function syncVersionTooltip() {
      var versionUrl = 'ds-version.json?t=' + Date.now();

      fetch(versionUrl, { cache: 'no-store' })
         .then(function (res) {
            if (!res.ok) throw new Error('ds-version.json unavailable');
            return res.json();
         })
         .then(function (data) {
            if (data && data.lastModified) {
               var fromJson = new Date(data.lastModified);
               if (!isNaN(fromJson.getTime())) {
                  applyVersionTooltip(fromJson);
                  return;
               }
            }
            applyVersionTooltip(getDsRevisionDateFromMeta());
         })
         .catch(function () {
            applyVersionTooltip(getDsRevisionDateFromMeta());
         });
   }

   // syncVersionTooltip();

   function removeDeprecatedMobileMenuItems() {
      var deprecatedLinks = document.querySelectorAll(
         'a[href="alfa-ds-mobile-sticky-cta.html"], a[href="alfa-ds-mobile-offer-card.html"], a[href="alfa-ds-mobile-skeleton.html"]'
      );
      deprecatedLinks.forEach(function (link) {
         var item = link.closest('li');
         if (item) item.remove();
      });
   }

   removeDeprecatedMobileMenuItems();

   function ensureTemplateSessionExpiredLink() {
      var currentFile = (location.pathname || '').replace(/\\/g, '/').split('/').pop() || '';
      var templateSubs = document.querySelectorAll('#ds-nav-sub-template');
      templateSubs.forEach(function (sub) {
         var existing = sub.querySelector('a[href$="alfa-ds-sessao-expirada.html"]');
         if (existing) {
            if (currentFile === 'alfa-ds-sessao-expirada.html') {
               existing.classList.add('is-active');
               existing.setAttribute('aria-current', 'page');
            }
            return;
         }

         var loginLink = sub.querySelector('a[href*="alfa-ds-template-login.html"]');
         var simulacaoLink = sub.querySelector('a[href*="alfa-ds-simulacao-credito.html"]');
         var hrefBase = '';
         if (loginLink) {
            hrefBase = loginLink.getAttribute('href') || '';
            hrefBase = hrefBase.replace('alfa-ds-template-login.html', 'alfa-ds-sessao-expirada.html');
         } else if (simulacaoLink) {
            hrefBase = (simulacaoLink.getAttribute('href') || '').replace('alfa-ds-simulacao-credito.html', 'alfa-ds-sessao-expirada.html');
         } else {
            hrefBase = 'alfa-ds-sessao-expirada.html';
         }

         var li = document.createElement('li');
         var a = document.createElement('a');
         a.href = hrefBase;
         a.textContent = 'Sessão expirada';
         if (currentFile === 'alfa-ds-sessao-expirada.html') {
            a.classList.add('is-active');
            a.setAttribute('aria-current', 'page');
         }
         li.appendChild(a);

         if (loginLink && loginLink.parentElement) {
            loginLink.parentElement.insertAdjacentElement('afterend', li);
         } else if (simulacaoLink && simulacaoLink.parentElement) {
            sub.insertBefore(li, simulacaoLink.parentElement);
         } else {
            sub.appendChild(li);
         }
      });
   }

   ensureTemplateSessionExpiredLink();

   var DS_COMPONENTES_PAGE = 'alfa-ds-componentes.html';
   var DS_TEMPLATES_PAGE = 'alfa-ds-templates.html';
   var DS_RELATORIO_MCB_PAGE = 'alfa-ds-relatorio-mcb.html';
   var DS_AGENTES_PAGE = 'alfa-ds-agentes-ia.html';

   function isComponentsNavHash(hash) {
      if (!hash) hash = location.hash;
      if (!hash) return false;
      return hash === '#componentes' || hash.indexOf('#comp-') === 0 || hash === '#tooltip' || hash === '#avatar';
   }

   function isTemplatesNavHash(hash) {
      if (!hash) hash = location.hash;
      if (!hash) return false;
      return hash === '#templates' || hash.indexOf('#tpl-chat') === 0 || hash.indexOf('#tpl-sessao-expirada') === 0;
   }

   function isOnComponentsPage() {
      var path = (location.pathname || '').replace(/\\/g, '/');
      return path.slice(-DS_COMPONENTES_PAGE.length) === DS_COMPONENTES_PAGE;
   }

   function isOnTemplatesPage() {
      var path = (location.pathname || '').replace(/\\/g, '/');
      return path.slice(-DS_TEMPLATES_PAGE.length) === DS_TEMPLATES_PAGE || path.slice(-DS_RELATORIO_MCB_PAGE.length) === DS_RELATORIO_MCB_PAGE;
   }

   function isOnRelatorioMcbPage() {
      var path = (location.pathname || '').replace(/\\/g, '/');
      return path.slice(-DS_RELATORIO_MCB_PAGE.length) === DS_RELATORIO_MCB_PAGE;
   }

   function isNavGroupHashForSub(subId, hash) {
      if (subId === 'ds-nav-sub-template') return isTemplatesNavHash(hash);
      return isComponentsNavHash(hash);
   }

   function subLinksToCurrentPage(sub) {
      var file = (location.pathname || '').replace(/\\/g, '/').split('/').pop() || '';
      var links = sub.querySelectorAll('a[href]');
      for (var i = 0; i < links.length; i++) {
         var href = (links[i].getAttribute('href') || '').split('#')[0];
         if (!href || href.indexOf('://') >= 0) continue;
         while (href.indexOf('../') === 0) href = href.slice(3);
         if (href === file) return true;
      }
      return false;
   }

   function shouldOpenNavGroupByContext(group, sub) {
      if (isNavGroupHashForSub(sub.id, location.hash)) return true;
      if (sub.querySelector("a.is-active, a[aria-current='page']")) return true;
      var groupTitle = group.querySelector('.ds-nav__group-title');
      if (groupTitle && (groupTitle.classList.contains('is-active') || groupTitle.hasAttribute('aria-current'))) {
         return true;
      }
      return subLinksToCurrentPage(sub);
   }

   if (location.hash === '#cursor') {
      location.replace(DS_AGENTES_PAGE);
   }

   function scrollToNavHash() {
      var hash = location.hash;
      if (!hash || hash.length < 2) return;
      var id = hash.slice(1);
      var el = document.getElementById(id);
      if (el) {
         window.requestAnimationFrame(function () {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
         });
      }
   }

   function markSubnavActive() {
      if (!isOnComponentsPage() && !isOnTemplatesPage()) return;
      var hash = location.hash;
      document.querySelectorAll('.ds-nav__sub a.is-active').forEach(function (a) {
         a.classList.remove('is-active');
      });
      if (isOnRelatorioMcbPage()) {
         document.querySelectorAll('.ds-nav__sub a[href="alfa-ds-relatorio-mcb.html"]').forEach(function (a) {
            a.classList.add('is-active');
         });
         return;
      }
      if (!hash) return;
      document.querySelectorAll('.ds-nav__sub a[href*="' + hash + '"]').forEach(function (a) {
         a.classList.add('is-active');
      });
   }

   document.querySelectorAll('[data-nav-group]').forEach(function (group) {
      var expander = group.querySelector('.ds-nav__group-expander');
      var sub = group.querySelector('.ds-nav__sub');
      var groupTitle = group.querySelector('.ds-nav__group-title');
      if (!expander || !sub) return;

      var navGroupStorageKey = group.getAttribute('data-nav-storage-key') || 'alfa-ds-nav-componentes-open';
      var submenuLabel = groupTitle ? groupTitle.textContent.trim() : 'menu';

      function setNavGroupOpen(open) {
         group.classList.toggle('is-open', open);
         expander.setAttribute('aria-expanded', open ? 'true' : 'false');
         expander.setAttribute('aria-label', open ? 'Recolher submenu ' + submenuLabel : 'Expandir submenu ' + submenuLabel);
         try {
            localStorage.setItem(navGroupStorageKey, open ? '1' : '0');
         } catch (e) {
            /* ignore */
         }
      }

      var storedOpen = false;
      try {
         var stored = localStorage.getItem(navGroupStorageKey);
         if (stored !== null) storedOpen = stored === '1';
      } catch (e) {
         /* ignore */
      }
      if (shouldOpenNavGroupByContext(group, sub)) storedOpen = true;
      setNavGroupOpen(storedOpen);

      expander.addEventListener('click', function (e) {
         e.preventDefault();
         e.stopPropagation();
         setNavGroupOpen(!group.classList.contains('is-open'));
      });

      if (groupTitle) {
         groupTitle.addEventListener('click', function (e) {
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
            var onSamePage = (sub.id === 'ds-nav-sub-template' && isOnTemplatesPage()) || (sub.id === 'ds-nav-sub-componentes' && isOnComponentsPage());
            if (onSamePage) {
               e.preventDefault();
               setNavGroupOpen(!group.classList.contains('is-open'));
               return;
            }
            if (!group.classList.contains('is-open')) {
               e.preventDefault();
               setNavGroupOpen(true);
            }
         });
      }

      sub.querySelectorAll('a').forEach(function (link) {
         link.addEventListener('click', function () {
            setNavGroupOpen(true);
         });
      });

      window.addEventListener('hashchange', function () {
         if (isNavGroupHashForSub(sub.id, location.hash)) setNavGroupOpen(true);
         markSubnavActive();
         scrollToNavHash();
      });
   });

   if (isOnComponentsPage() || isOnTemplatesPage()) {
      markSubnavActive();
      scrollToNavHash();
   }

   if (location.hash === '#cursor') {
      location.replace(DS_AGENTES_PAGE);
   }

   var shell = document.getElementById('dsShell');
   var sidebarToggle = document.getElementById('dsSidebarToggle');
   var sidebarStorageKey = 'alfa-ds-sidebar-collapsed';

   function syncNavLinkTitles(collapsed) {
      document.querySelectorAll('.ds-nav a, .ds-nav__group-title').forEach(function (link) {
         var label = link.querySelector('.ds-nav__label');
         if (!label) return;
         if (collapsed) {
            link.setAttribute('title', label.textContent.trim());
         } else {
            link.removeAttribute('title');
         }
      });
   }

   function setSidebarCollapsed(collapsed) {
      if (!shell || !sidebarToggle) return;
      shell.classList.toggle('ds-shell--sidebar-collapsed', collapsed);
      sidebarToggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      sidebarToggle.setAttribute('aria-label', collapsed ? 'Expandir menu lateral' : 'Recolher menu lateral');
      syncNavLinkTitles(collapsed);
      try {
         localStorage.setItem(sidebarStorageKey, collapsed ? '1' : '0');
      } catch (e) {
         /* ignore */
      }
   }

   if (shell && sidebarToggle) {
      var storedCollapsed = false;
      try {
         storedCollapsed = localStorage.getItem(sidebarStorageKey) === '1';
      } catch (e) {
         /* ignore */
      }
      setSidebarCollapsed(storedCollapsed);

      sidebarToggle.addEventListener('click', function () {
         setSidebarCollapsed(!shell.classList.contains('ds-shell--sidebar-collapsed'));
      });
   }

   function navIconSvg(paths, viewBox) {
      return (
         '<svg class="ds-nav__icon-svg" width="20" height="20" viewBox="' +
         (viewBox || '0 0 24 24') +
         '" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
         paths +
         '</svg>'
      );
   }

   var DS_NAV_ICON_48 = {
      cores: '<path fill-rule="evenodd" clip-rule="evenodd" d="M28.8253 24.6604C27.16 21.5697 24.6016 19.7094 22.7978 18.711C26.4326 13.483 31.801 8.71916 39.5074 7.99571C38.7839 15.667 34.0415 21.0237 28.8253 24.6604M22.5584 28.2188C21.7414 26.8752 20.6162 25.752 19.2707 24.9369C19.7114 23.9853 20.1872 23.0162 20.741 22.0217C22.1002 22.7451 24.2296 24.2154 25.5029 26.7309C24.4967 27.2906 23.5178 27.7742 22.5584 28.2188M14.2513 39.1001H8.40133V33.2501C8.40133 30.0248 11.026 27.4001 14.2513 27.4001C17.4765 27.4001 20.1013 30.0248 20.1013 33.2501C20.1013 36.4773 17.4786 39.1001 14.2513 39.1001M43.5 5.95C43.5 4.8736 42.6284 4 41.55 4C27.2916 4 19.4721 15.1949 15.5975 23.6365C15.1529 23.5741 14.7122 23.5 14.25 23.5C8.8758 23.5 4.5 27.8739 4.5 33.25V41.05C4.5 42.1284 5.3736 43 6.45 43H14.25C19.6262 43 24 38.6262 24 33.25C24 32.7898 23.9259 32.3472 23.8654 31.9045C32.3051 28.0299 43.5 20.2104 43.5 5.95" fill="currentColor"/>',
      tipografia:
         '<path fill-rule="evenodd" clip-rule="evenodd" d="M24.8929 27.8999C23.4148 24.0448 21.7554 19.8152 20.4723 16.5704C19.1755 20.1389 17.6877 24.1988 16.3032 27.8999H24.8929ZM31.7003 35.0837C32.2853 36.8368 32.4218 38.3285 32.2112 39.5999H36.4953C36.2964 39.2704 36.0995 38.9096 35.9045 38.5216C34.1514 35.0135 26.562 13.936 24.5769 8.39991H23.4225C23.1827 9.06876 22.857 9.97551 22.4748 11.0402C24.2103 15.4004 30.0428 30.1073 31.7003 35.0837V35.0837ZM6.45 43.5C5.3736 43.5 4.5 42.6264 4.5 41.55C4.5 40.5341 5.2761 39.7014 6.2667 39.6078C6.4266 39.5532 7.4328 39.1242 8.60475 36.7783C10.1063 33.7773 16.8552 15.1977 20.2131 5.7948C20.49 5.0187 21.2252 4.5 22.05 4.5H25.95C26.7749 4.5 27.51 5.0187 27.7869 5.7948C31.1448 15.1977 37.8938 33.7773 39.3953 36.7783C40.5672 39.1242 41.5734 39.5532 41.7333 39.6078C42.7239 39.7014 43.5 40.5341 43.5 41.55C43.5 42.6264 42.6264 43.5 41.55 43.5H27.9C26.8509 43.5 26.0319 42.6673 25.9929 41.6202C25.9539 40.573 26.7944 39.68 27.8396 39.6C27.8532 39.6 28.1457 39.5766 28.2783 39.3758C28.3602 39.2529 28.7365 38.5236 27.9994 36.3162C27.6309 35.2125 27.044 33.5901 26.342 31.72C26.2113 31.7493 26.0885 31.8 25.95 31.8H14.8292C14.4372 32.8257 14.0648 33.7871 13.7255 34.6451C13.5519 37.9386 15.5214 40.0602 15.6365 40.1792C16.3911 40.9416 16.3872 42.1701 15.6286 42.9287C15.2484 43.3089 14.7492 43.5 14.25 43.5H6.45Z" fill="currentColor"/>',
      grid: '<path fill-rule="evenodd" clip-rule="evenodd" d="M41.55 4.5H6.45C5.37165 4.5 4.5 5.37165 4.5 6.45V41.55C4.5 42.6284 5.37165 43.5 6.45 43.5H41.55C42.6284 43.5 43.5 42.6284 43.5 41.55V6.45C43.5 5.37165 42.6284 4.5 41.55 4.5V4.5ZM8.39973 39.6001H39.5997V8.40007H8.39973V39.6001ZM22.0503 18.15H33.7503C34.8286 18.15 35.7003 17.2783 35.7003 16.2C35.7003 15.1216 34.8286 14.25 33.7503 14.25H22.0503C20.9719 14.25 20.1003 15.1216 20.1003 16.2C20.1003 17.2783 20.9719 18.15 22.0503 18.15M14.2501 18.15C15.3285 18.15 16.2001 17.2783 16.2001 16.2C16.2001 15.1216 15.3285 14.25 14.2501 14.25C13.1718 14.25 12.3001 15.1216 12.3001 16.2C12.3001 17.2783 13.1718 18.15 14.2501 18.15M22.0503 25.95H33.7503C34.8286 25.95 35.7003 25.0783 35.7003 24C35.7003 22.9216 34.8286 22.05 33.7503 22.05H22.0503C20.9719 22.05 20.1003 22.9216 20.1003 24C20.1003 25.0783 20.9719 25.95 22.0503 25.95M14.2501 25.95C15.3285 25.95 16.2001 25.0783 16.2001 24C16.2001 22.9216 15.3285 22.05 14.2501 22.05C13.1718 22.05 12.3001 22.9216 12.3001 24C12.3001 25.0783 13.1718 25.95 14.2501 25.95M22.0503 33.7499H33.7503C34.8286 33.7499 35.7003 32.8783 35.7003 31.7999C35.7003 30.7216 34.8286 29.8499 33.7503 29.8499H22.0503C20.9719 29.8499 20.1003 30.7216 20.1003 31.7999C20.1003 32.8783 20.9719 33.7499 22.0503 33.7499M14.2501 33.7499C15.3285 33.7499 16.2001 32.8783 16.2001 31.7999C16.2001 30.7216 15.3285 29.8499 14.2501 29.8499C13.1718 29.8499 12.3001 30.7216 12.3001 31.7999C12.3001 32.8783 13.1718 33.7499 14.2501 33.7499" fill="currentColor"/>',
      componentes:
         '<path fill-rule="evenodd" clip-rule="evenodd" d="M35.7 16.2C33.36 16.2 31.2794 17.2569 29.85 18.8949C28.4207 17.2569 26.34 16.2 24 16.2C21.6581 16.2 19.5813 17.2569 18.15 18.8949C16.7187 17.2569 14.642 16.2 12.3 16.2C7.9983 16.2 4.5 19.6983 4.5 24C4.5 28.3017 7.9983 31.8 12.3 31.8C14.642 31.8 16.7187 30.7431 18.15 29.1051C19.5813 30.7431 21.6581 31.8 24 31.8C26.34 31.8 28.4207 30.7431 29.85 29.1051C31.2794 30.7431 33.36 31.8 35.7 31.8C40.0017 31.8 43.5 28.3017 43.5 24C43.5 19.6983 40.0017 16.2 35.7 16.2M35.7001 27.8999C33.5493 27.8999 31.8001 26.1508 31.8001 23.9999C31.8001 21.8491 33.5493 20.0999 35.7001 20.0999C37.851 20.0999 39.6001 21.8491 39.6001 23.9999C39.6001 26.1508 37.851 27.8999 35.7001 27.8999M24.0003 27.8999C21.8494 27.8999 20.1003 26.1508 20.1003 23.9999C20.1003 21.8491 21.8494 20.0999 24.0003 20.0999C26.1511 20.0999 27.9003 21.8491 27.9003 23.9999C27.9003 26.1508 26.1511 27.8999 24.0003 27.8999M12.3001 27.8999C10.1492 27.8999 8.40007 26.1508 8.40007 23.9999C8.40007 21.8491 10.1492 20.0999 12.3001 20.0999C14.4509 20.0999 16.2001 21.8491 16.2001 23.9999C16.2001 26.1508 14.4509 27.8999 12.3001 27.8999M8.4 39.6001C8.4 38.5217 7.5264 37.6501 6.45 37.6501C5.3736 37.6501 4.5 38.5217 4.5 39.6001V41.5501C4.5 42.6284 5.3736 43.5001 6.45 43.5001H8.4C9.4764 43.5001 10.35 42.6284 10.35 41.5501C10.35 40.4717 9.4764 39.6001 8.4 39.6001M41.5497 37.6501C40.4714 37.6501 39.5997 38.5217 39.5997 39.6001C38.5214 39.6001 37.6497 40.4717 37.6497 41.5501C37.6497 42.6284 38.5214 43.5001 39.5997 43.5001H41.5497C42.6281 43.5001 43.4997 42.6284 43.4997 41.5501V39.6001C43.4997 38.5217 42.6281 37.6501 41.5497 37.6501M41.5497 4.5H39.5997C38.5214 4.5 37.6497 5.3736 37.6497 6.45C37.6497 7.5264 38.5214 8.4 39.5997 8.4C39.5997 9.4764 40.4714 10.35 41.5497 10.35C42.6281 10.35 43.4997 9.4764 43.4997 8.4V6.45C43.4997 5.3736 42.6281 4.5 41.5497 4.5M6.45 10.35C7.5264 10.35 8.4 9.4764 8.4 8.4C9.4764 8.4 10.35 7.5264 10.35 6.45C10.35 5.3736 9.4764 4.5 8.4 4.5H6.45C5.3736 4.5 4.5 5.3736 4.5 6.45V8.4C4.5 9.4764 5.3736 10.35 6.45 10.35M16.2 8.4H20.1C21.1764 8.4 22.05 7.5264 22.05 6.45C22.05 5.3736 21.1764 4.5 20.1 4.5H16.2C15.1236 4.5 14.25 5.3736 14.25 6.45C14.25 7.5264 15.1236 8.4 16.2 8.4M27.8999 8.4H31.7999C32.8782 8.4 33.7499 7.5264 33.7499 6.45C33.7499 5.3736 32.8782 4.5 31.7999 4.5H27.8999C26.8215 4.5 25.9499 5.3736 25.9499 6.45C25.9499 7.5264 26.8215 8.4 27.8999 8.4M20.1 39.5999H16.2C15.1236 39.5999 14.25 40.4716 14.25 41.5499C14.25 42.6283 15.1236 43.4999 16.2 43.4999H20.1C21.1764 43.4999 22.05 42.6283 22.05 41.5499C22.05 40.4716 21.1764 39.5999 20.1 39.5999M31.7999 39.5999H27.8999C26.8215 39.5999 25.9499 40.4716 25.9499 41.5499C25.9499 42.6283 26.8215 43.4999 27.8999 43.4999H31.7999C32.8782 43.4999 33.7499 42.6283 33.7499 41.5499C33.7499 40.4716 32.8782 39.5999 31.7999 39.5999" fill="currentColor"/>',
      icones:
         '<path fill-rule="evenodd" clip-rule="evenodd" d="M25.2021 39.5997L31.7969 26.41L38.3918 39.5997H25.2021ZM12.2993 35.6999V23.8031C12.9291 23.9318 13.5804 24 14.2493 24C19.6254 24 23.9992 19.6262 23.9992 14.2501C23.9992 13.5813 23.9309 12.93 23.8003 12.3001H35.6991V25.4898L33.5424 21.1784C32.8814 19.8563 30.7169 19.8563 30.0539 21.1784L22.7941 35.6999H12.2993ZM14.2513 8.40006C17.4765 8.40006 20.1012 11.0247 20.1012 14.25C20.1012 17.4753 17.4765 20.1 14.2513 20.1C11.026 20.1 8.4013 17.4753 8.4013 14.25C8.4013 11.0247 11.026 8.40006 14.2513 8.40006V8.40006ZM43.293 40.6781L39.5997 33.2896V10.35C39.5997 9.27161 38.7281 8.39997 37.6497 8.39997H21.9992C20.2169 6.04634 17.4225 4.5 14.2499 4.5C8.87382 4.5 4.5 8.87382 4.5 14.2499C4.5 17.4225 6.04634 20.2188 8.39997 22.0011V37.6497C8.39997 38.7281 9.27161 39.5997 10.35 39.5997H20.8448L20.3046 40.6781C20.0024 41.2806 20.0355 41.9982 20.3904 42.5735C20.7473 43.1487 21.3732 43.4997 22.0499 43.4997H41.5497C42.2264 43.4997 42.8523 43.1487 43.2072 42.5735C43.564 41.9982 43.5972 41.2806 43.293 40.6781V40.6781Z" fill="currentColor"/>',
      marca: '<path fill-rule="evenodd" clip-rule="evenodd" d="M41.55 4H6.45C5.3736 4 4.5 4.8736 4.5 5.95V41.05C4.5 42.1264 5.3736 43 6.45 43H41.55C42.6264 43 43.5 42.1264 43.5 41.05V5.95C43.5 4.8736 42.6264 4 41.55 4V4ZM20.1013 15.6998C21.1758 15.6998 22.0513 16.5754 22.0513 17.6498C22.0513 18.7243 21.1758 19.5998 20.1013 19.5998C19.0269 19.5998 18.1513 18.7243 18.1513 17.6498C18.1513 16.5754 19.0269 15.6998 20.1013 15.6998M20.1 23.5002C23.3253 23.5002 25.95 20.8755 25.95 17.6502C25.95 14.4249 23.3253 11.8002 20.1 11.8002C16.8747 11.8002 14.25 14.4249 14.25 17.6502C14.25 20.8755 16.8747 23.5002 20.1 23.5002M8.40133 39.1002V34.3539L16.1467 29.707L20.9691 32.9226C21.7452 33.4393 22.7728 33.336 23.43 32.6788L31.9456 24.1632L39.6013 30.2862V39.1002H8.40133ZM39.6013 7.90008V25.2921L33.0201 20.0271C32.244 19.4051 31.1227 19.4694 30.4227 20.1714L21.8037 28.7904L17.2836 25.7777C16.6557 25.3604 15.8425 25.3389 15.1971 25.7289L8.40133 29.8064V7.90008H39.6013Z" fill="currentColor"/>',
      inicio:
         '<path fill-rule="evenodd" clip-rule="evenodd" d="M42.8453 20.5918L25.2948 4.99141C24.5558 4.3362 23.4442 4.3362 22.7052 4.99141L20.0999 7.30808V6.45005C20.0999 5.37362 19.2282 4.5 18.1498 4.5H10.3496C9.27125 4.5 8.39958 5.37362 8.39958 6.45005V17.7077L5.15469 20.5918C4.34932 21.3095 4.27717 22.5399 4.99284 23.3473C5.70655 24.1507 6.93899 24.2189 7.74436 23.5091L8.39958 22.9261V41.551C8.39958 42.6274 9.27125 43.5011 10.3496 43.5011H37.6504C38.7288 43.5011 39.6004 42.6274 39.6004 41.551V22.9261L40.2556 23.5091C40.6262 23.8387 41.0903 24.0005 41.5505 24.0005C42.0867 24.0005 42.623 23.7802 43.0072 23.3473C43.7228 22.5399 43.6507 21.3095 42.8453 20.5918V20.5918ZM35.7001 39.6001H31.8V29.8499C31.8 28.7734 30.9283 27.8998 29.8499 27.8998H18.1496C17.0712 27.8998 16.1996 28.7734 16.1996 29.8499V39.6001H12.2995V19.458L23.9998 9.05841L35.7001 19.458V39.6001ZM20.1003 39.6003H27.9005V31.8001H20.1003V39.6003ZM12.2995 8.39956H16.1996V10.7747L12.2995 14.2419V8.39956Z" fill="currentColor"/>',
      dashboard:
         '<path fill-rule="evenodd" clip-rule="evenodd" d="M41.55 39.5999C42.6264 39.5999 43.5 40.4735 43.5 41.5499C43.5 42.6263 42.6264 43.4999 41.55 43.4999H6.45C5.3736 43.4999 4.5 42.6263 4.5 41.5499C4.5 40.4735 5.3736 39.5999 6.45 39.5999H41.55ZM41.55 4.5C42.6264 4.5 43.5 5.3736 43.5 6.45V33.75C43.5 34.8264 42.6264 35.7 41.55 35.7H6.45C5.3736 35.7 4.5 34.8264 4.5 33.75V22.05C4.5 20.9736 5.3736 20.1 6.45 20.1H16.2V14.25C16.2 13.1736 17.0736 12.3 18.15 12.3H27.9V6.45C27.9 5.3736 28.7736 4.5 29.85 4.5H41.55ZM31.7993 31.8001H39.5993V8.4001H31.7993V31.8001ZM20.1003 31.7998H27.9003V16.1998H20.1003V31.7998ZM8.39969 31.8H16.1997V24H8.39969V31.8Z" fill="currentColor"/>',
      templates:
         '<path fill-rule="evenodd" clip-rule="evenodd" d="M24 31.3H39.6V23.5H24V31.3ZM31.7993 39.1H12.2993V17.65H18.1493C19.2218 17.65 20.0993 16.7725 20.0993 15.7V13.75H31.7993V19.6H22.0493C20.9768 19.6 20.0993 20.4775 20.0993 21.55V33.25C20.0993 34.3225 20.9768 35.2 22.0493 35.2H31.7993V39.1ZM8.39967 13.7501H16.1997V7.90008H8.39967V13.7501ZM41.55 19.6H35.7V11.8C35.7 10.7275 34.8225 9.85 33.75 9.85H20.1V5.95C20.1 4.8775 19.2225 4 18.15 4H6.45C5.3775 4 4.5 4.8775 4.5 5.95V15.7C4.5 16.7725 5.3775 17.65 6.45 17.65H8.4V41.05C8.4 42.1225 9.2775 43 10.35 43H33.75C34.8225 43 35.7 42.1225 35.7 41.05V35.2H41.55C42.6225 35.2 43.5 34.3225 43.5 33.25V21.55C43.5 20.4775 42.6225 19.6 41.55 19.6V19.6Z" fill="currentColor"/>',
      instalacao:
         '<path fill-rule="evenodd" clip-rule="evenodd" d="M41.0625 21.5628C42.4104 21.5628 43.5 22.6548 43.5 24.0003V41.0628C43.5 42.4083 42.4104 43.5003 41.0625 43.5003H6.9375C5.58956 43.5003 4.5 42.4083 4.5 41.0628V24.0003C4.5 22.6548 5.58956 21.5628 6.9375 21.5628C8.28544 21.5628 9.375 22.6548 9.375 24.0003V31.3128H15.1811C16.1049 31.3128 16.9483 31.8345 17.3603 32.6608L19.125 36.1878H28.875L30.6397 32.6608C31.0517 31.8345 31.8951 31.3128 32.8189 31.3128H38.625V24.0003C38.625 22.6548 39.7146 21.5628 41.0625 21.5628ZM19.8391 20.8489L12.5266 13.5364C11.5736 12.5834 11.5736 11.0429 12.5266 10.0898C13.4797 9.13674 15.0202 9.13674 15.9732 10.0898L21.5624 15.679L32.0266 5.2148C32.9797 4.26173 34.5202 4.26173 35.4732 5.2148C36.4263 6.16786 36.4263 7.70836 35.4732 8.66142L23.2857 20.8489C22.8104 21.3242 22.1864 21.5631 21.5624 21.5631C20.9384 21.5631 20.3144 21.3242 19.8391 20.8489Z" fill="currentColor"/>',
   };

   var DS_NAV_ICON_VIEWBOX_48 = '0 0 48 48';

   var DS_NAV_ICON_PATHS = {
      'alfa-design-system.html': DS_NAV_ICON_48.inicio,
      'alfa-ds-marca.html': DS_NAV_ICON_48.marca,
      'alfa-ds-cores.html': DS_NAV_ICON_48.cores,
      'alfa-ds-tipografia.html': DS_NAV_ICON_48.tipografia,
      'alfa-ds-grid.html': DS_NAV_ICON_48.grid,
      'alfa-ds-componentes.html': DS_NAV_ICON_48.componentes,
      'alfa-ds-icones.html': DS_NAV_ICON_48.icones,
      'alfa-ds-templates.html': DS_NAV_ICON_48.templates,
      'alfa-ds-agentes-ia.html': DS_NAV_ICON_48.instalacao,
      'dashboard-dist/index.html': DS_NAV_ICON_48.dashboard,
   };

   function getNavHrefFile(href) {
      if (!href) return '';
      var clean = href.split('#')[0].split('?')[0];
      var parts = clean.replace(/\\/g, '/').split('/');
      return parts[parts.length - 1] || clean;
   }

   function getNavLinkLabel(link) {
      var labelEl = link.querySelector('.ds-nav__label');
      return (labelEl ? labelEl.textContent : link.textContent).trim();
   }

   function getNavIconFileKey(href) {
      var file = getNavHrefFile(href);
      var hrefNorm = (href || '').replace(/\\/g, '/');
      var pathNorm = (location.pathname || '').replace(/\\/g, '/');
      if (hrefNorm.indexOf('dashboard-dist') !== -1 || (file === 'index.html' && pathNorm.indexOf('dashboard-dist') !== -1)) {
         return 'dashboard-dist/index.html';
      }
      return file;
   }

   function resolveNavIconPaths(href) {
      var file = getNavIconFileKey(href);
      var paths = DS_NAV_ICON_PATHS[file];
      if (!paths) return null;
      return { paths: paths, viewBox: DS_NAV_ICON_VIEWBOX_48 };
   }

   function applyNavLinkIcon(link) {
      if (!link) return;
      var icon = resolveNavIconPaths(link.getAttribute('href'));
      if (!icon) return;
      var labelText = getNavLinkLabel(link) || link.textContent.trim();
      link.innerHTML =
         '<span class="ds-nav__icon" aria-hidden="true">' + navIconSvg(icon.paths, icon.viewBox) + '</span>' + '<span class="ds-nav__label">' + labelText + '</span>';
      link.setAttribute('title', labelText);
   }

   function initSidebarNavIcons() {
      document.querySelectorAll('.ds-nav > li > a').forEach(applyNavLinkIcon);
      document.querySelectorAll('.ds-nav__group-title').forEach(applyNavLinkIcon);
   }

   initSidebarNavIcons();

   (function initSidebarNavSearch() {
      var navRoot = document.getElementById('dsSidebarNav');
      var searchInput = document.getElementById('dsSidebarSearch');
      var searchClear = document.getElementById('dsSidebarSearchClear');
      var searchEmpty = document.getElementById('dsSidebarSearchEmpty');
      if (!navRoot || !searchInput) return;

      var topList = navRoot.querySelector('.ds-nav');
      if (!topList) return;

      function normalizeNavQuery(value) {
         return (value || '')
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .trim();
      }

      function getLinkSearchText(link) {
         var stored = link.getAttribute('data-nav-search');
         if (stored) return stored;
         var text = (link.textContent || '').trim();
         var group = link.closest('[data-nav-group]');
         if (group && link.closest('.ds-nav__sub')) {
            var groupTitle = group.querySelector('.ds-nav__group-title');
            if (groupTitle) {
               text = groupTitle.textContent.trim() + ' ' + text;
            }
         }
         link.setAttribute('data-nav-search', text);
         return text;
      }

      topList.querySelectorAll('a[href]').forEach(function (link) {
         getLinkSearchText(link);
      });

      function setItemHidden(li, hidden) {
         if (!li) return;
         li.classList.toggle('ds-nav__item--hidden', hidden);
      }

      function filterSidebarNav() {
         var query = normalizeNavQuery(searchInput.value);
         var hasQuery = query.length > 0;

         if (searchClear) searchClear.hidden = !hasQuery;
         if (searchEmpty) searchEmpty.hidden = true;

         if (!hasQuery) {
            topList.querySelectorAll('li').forEach(function (li) {
               setItemHidden(li, false);
               li.classList.remove('ds-nav__group--search-open');
            });
            return;
         }

         var anyVisible = false;

         topList.querySelectorAll(':scope > li').forEach(function (li) {
            if (li.hasAttribute('data-nav-group')) {
               var groupTitleLink = li.querySelector('.ds-nav__group-title');
               var groupText = groupTitleLink ? normalizeNavQuery(getLinkSearchText(groupTitleLink)) : '';
               var groupMatch = groupText.indexOf(query) !== -1;
               var hasVisibleSub = false;

               li.querySelectorAll('.ds-nav__sub > li').forEach(function (subLi) {
                  var subLink = subLi.querySelector('a');
                  if (!subLink) return;
                  var subMatch = normalizeNavQuery(getLinkSearchText(subLink)).indexOf(query) !== -1;
                  var show = groupMatch || subMatch;
                  setItemHidden(subLi, !show);
                  if (show) hasVisibleSub = true;
               });

               setItemHidden(li, !groupMatch && !hasVisibleSub);
               li.classList.toggle('ds-nav__group--search-open', groupMatch || hasVisibleSub);

               if (!li.classList.contains('ds-nav__item--hidden')) anyVisible = true;
               return;
            }

            var link = li.querySelector(':scope > a');
            if (!link) return;
            var match = !hasQuery || normalizeNavQuery(getLinkSearchText(link)).indexOf(query) !== -1;
            setItemHidden(li, !match);
            if (match) anyVisible = true;
         });

         if (searchEmpty) searchEmpty.hidden = !hasQuery || anyVisible;
      }

      function clearSidebarNavSearch() {
         searchInput.value = '';
         filterSidebarNav();
         searchInput.focus();
      }

      searchInput.addEventListener('input', filterSidebarNav);
      searchInput.addEventListener('search', filterSidebarNav);

      if (searchClear) {
         searchClear.addEventListener('click', clearSidebarNavSearch);
      }

      searchInput.addEventListener('keydown', function (e) {
         if (e.key === 'Escape') {
            clearSidebarNavSearch();
         }
      });
   })();

   (function initSearchAffixFields() {
      document.querySelectorAll('[data-search-field]').forEach(function (field) {
         var input = field.querySelector('.ds-textfield--affix input[type="search"]') || field.querySelector('.ds-textfield--affix .ds-textfield__input');
         var clearBtn = field.querySelector('.ds-textfield__affix-btn--clear');
         var searchBtn = field.querySelector('[data-search-submit]');
         if (!input) return;

         function runSearch() {
            field.dispatchEvent(
               new CustomEvent('ds-search', {
                  bubbles: true,
                  detail: { query: input.value.trim() },
               })
            );
         }

         function syncClear() {
            if (clearBtn) clearBtn.hidden = !input.value.trim();
         }

         input.addEventListener('input', syncClear);
         input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
               e.preventDefault();
               runSearch();
            }
         });

         if (clearBtn) {
            clearBtn.addEventListener('click', function () {
               input.value = '';
               syncClear();
               input.focus();
            });
         }

         if (searchBtn) {
            searchBtn.addEventListener('click', runSearch);
         }

         syncClear();
      });
   })();

   (function initInputMasks() {
      function maskCpf(value) {
         var digits = String(value || '')
            .replace(/\D/g, '')
            .slice(0, 11);
         return digits
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      }

      function maskCnpj(value) {
         var digits = String(value || '')
            .replace(/\D/g, '')
            .slice(0, 14);
         return digits
            .replace(/^(\d{2})(\d)/, '$1.$2')
            .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
            .replace(/\.(\d{3})(\d)/, '.$1/$2')
            .replace(/(\d{4})(\d)/, '$1-$2');
      }

      function maskTelefone(value) {
         var digits = String(value || '')
            .replace(/\D/g, '')
            .slice(0, 10);
         return digits.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2');
      }

      function maskCelular(value) {
         var digits = String(value || '')
            .replace(/\D/g, '')
            .slice(0, 11);
         return digits.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2');
      }

      function maskCurrency(value) {
         var digits = String(value || '')
            .replace(/\D/g, '')
            .slice(0, 15);
         if (!digits) return '';
         var num = parseInt(digits, 10) / 100;
         return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      }

      function maskCpfCnpj(value) {
         var digits = String(value || '').replace(/\D/g, '');
         if (digits.length <= 11) return maskCpf(value);
         return maskCnpj(value);
      }

      var masks = {
         cpf: maskCpf,
         cnpj: maskCnpj,
         'cpf-cnpj': maskCpfCnpj,
         telefone: maskTelefone,
         celular: maskCelular,
         currency: maskCurrency,
      };

      document.querySelectorAll('[data-input-mask]').forEach(function (input) {
         var maskFn = masks[input.getAttribute('data-input-mask')];
         if (!maskFn) return;
         if (!input.readOnly && !input.disabled) {
            input.addEventListener('input', function () {
               input.value = maskFn(input.value);
            });
         }
         if (input.value) {
            input.value = maskFn(input.value);
         }
      });
   })();

   function getActionTooltip(btn) {
      return btn.querySelector('.ds-icon-action-btn__tooltip');
   }

   function setActionFeedback(btn, tooltipText, successClass) {
      var tooltip = getActionTooltip(btn);
      var defaultTip = btn.getAttribute('data-tooltip-default') || btn.getAttribute('data-copy-label') || btn.getAttribute('data-download-label') || '';
      if (tooltip) {
         tooltip.textContent = tooltipText;
      } else if (defaultTip) {
         btn.setAttribute('aria-label', tooltipText);
      }
      if (successClass) btn.classList.add(successClass);
      window.setTimeout(function () {
         if (tooltip) {
            tooltip.textContent = defaultTip;
         } else if (defaultTip) {
            btn.setAttribute('aria-label', defaultTip);
         }
         if (successClass) btn.classList.remove(successClass);
      }, 2000);
   }

   function formatSvg(svg) {
      var clone = svg.cloneNode(true);
      if (!clone.getAttribute('xmlns')) {
         clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      }
      return clone.outerHTML.replace(/\s+/g, ' ').replace(/>\s+</g, '><').trim();
   }

   function copyText(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
         return navigator.clipboard.writeText(text);
      }
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try {
         document.execCommand('copy');
         return Promise.resolve();
      } finally {
         document.body.removeChild(ta);
      }
   }

   function getAssetSvg(btn) {
      var box = btn.closest('.ds-brand-box, .ds-icon-card, .ds-loader-card');
      if (!box) return null;
      var iconPart = btn.getAttribute('data-copy-icon-part');
      if (iconPart) {
         return box.querySelector('.ds-icon-card__preview svg[data-icon-part="' + iconPart + '"]');
      }
      return box.querySelector('.ds-brand-box__preview svg, .ds-icon-card__preview svg, .ds-loader-card__preview svg');
   }

   document.querySelectorAll('.ds-copy-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
         var textToCopy;
         var copyTarget = btn.getAttribute('data-copy-target');

         if (copyTarget) {
            var targetEl = document.querySelector(copyTarget);
            if (!targetEl) return;
            textToCopy = targetEl.textContent.trim();
         } else {
            var svg = getAssetSvg(btn);
            if (!svg) return;
            textToCopy = formatSvg(svg);
         }

         copyText(textToCopy)
            .then(function () {
               setActionFeedback(btn, btn.getAttribute('data-tooltip-success') || 'Copiado!', 'is-copied');
            })
            .catch(function () {
               setActionFeedback(btn, 'Erro', 'is-copied');
            });
      });
   });

   document.querySelectorAll('[data-comp-doc-tabs]').forEach(function (root) {
      var tablist = root.querySelector('.ds-comp-doc-tabs__list');
      if (!tablist) return;
      var tabs = tablist.querySelectorAll('[data-comp-doc-tab]');
      var panels = root.querySelectorAll('[data-comp-doc-panel]');
      tabs.forEach(function (tab) {
         tab.addEventListener('click', function () {
            var key = tab.getAttribute('data-comp-doc-tab');
            tabs.forEach(function (t) {
               t.classList.remove('ds-tabs__tab--active');
               t.setAttribute('aria-selected', 'false');
            });
            tab.classList.add('ds-tabs__tab--active');
            tab.setAttribute('aria-selected', 'true');
            panels.forEach(function (panel) {
               var isActive = panel.getAttribute('data-comp-doc-panel') === key;
               panel.classList.toggle('is-active', isActive);
               if (isActive) {
                  panel.removeAttribute('hidden');
               } else {
                  panel.setAttribute('hidden', '');
               }
            });
         });
      });
   });

   document.querySelectorAll('[data-formulario-tabs]').forEach(function (root) {
      var tablist = root.querySelector('.ds-tabs');
      if (!tablist) return;
      var tabs = tablist.querySelectorAll('.ds-tabs__tab[data-formulario-tab]');
      var panels = root.querySelectorAll('[data-formulario-panel]');
      tabs.forEach(function (tab) {
         tab.addEventListener('click', function () {
            var key = tab.getAttribute('data-formulario-tab');
            tabs.forEach(function (t) {
               t.classList.remove('ds-tabs__tab--active');
               t.setAttribute('aria-selected', 'false');
            });
            tab.classList.add('ds-tabs__tab--active');
            tab.setAttribute('aria-selected', 'true');
            panels.forEach(function (panel) {
               var isActive = panel.getAttribute('data-formulario-panel') === key;
               if (isActive) {
                  panel.removeAttribute('hidden');
               } else {
                  panel.setAttribute('hidden', '');
               }
            });
         });
      });
   });

   (function initFormularioValidation() {
      var section = document.getElementById('formulario-gerar-arquivo');
      if (!section) return;

      var form = section.querySelector('#form-gerar-arquivo');
      var submitBtn = section.querySelector('[data-formulario-submit]');
      var summary = section.querySelector('#form-validation-summary');
      var tabsWrap = section.querySelector('[data-formulario-tabs]');
      var dadosTab = tabsWrap && tabsWrap.querySelector('[data-formulario-tab="dados"]');
      var REQUIRED_MSG = 'Preencha este campo.';

      if (!form || !submitBtn) return;

      function createValidationErrorBtn(message) {
         var btn = document.createElement('button');
         btn.type = 'button';
         btn.className = 'ds-textfield__error-btn';
         btn.setAttribute('data-formulario-validation', '');
         btn.setAttribute('aria-label', message);
         btn.innerHTML = '<span aria-hidden="true">!</span>';
         return btn;
      }

      function ensureFieldErrorMessage(field, message) {
         if (!field) return null;
         var err = field.querySelector('.ds-field__error[data-formulario-validation]');
         if (!err) {
            err = document.createElement('p');
            err.className = 'ds-field__error';
            err.setAttribute('data-formulario-validation', '');
            field.appendChild(err);
         }
         err.textContent = message;
         return err;
      }

      function isComboboxEmpty(combobox) {
         if (!combobox) return true;
         if (combobox.hasAttribute('data-combobox-multi')) {
            return combobox.querySelectorAll('.ds-combobox__checkbox-input:checked').length === 0;
         }
         var valueEl = combobox.querySelector('[data-combobox-value]');
         var value = valueEl ? valueEl.textContent.trim() : '';
         return !value || value === 'Selecione';
      }

      function isFieldEmpty(field) {
         var input = field.querySelector('.ds-textfield__input');
         if (input) return !input.value.trim();
         var combobox = field.querySelector('[data-combobox-multi]') || field.querySelector('[data-combobox]');
         return isComboboxEmpty(combobox);
      }

      function showTextfieldError(field, input, message) {
         var shell = input.closest('.ds-textfield');
         if (!shell) return;
         input.setAttribute('aria-invalid', 'true');
         ensureFieldErrorMessage(field, message);
      }

      function showComboboxError(field, combobox, message) {
         if (!combobox) return;
         var trigger = combobox.querySelector('.ds-combobox__trigger');
         if (trigger) trigger.setAttribute('aria-invalid', 'true');
         ensureFieldErrorMessage(field, message);
      }

      function showFieldError(field, message) {
         var input = field.querySelector('.ds-textfield__input');
         if (input) {
            showTextfieldError(field, input, message);
            return;
         }
         var combobox = field.querySelector('[data-combobox-multi]') || field.querySelector('[data-combobox]');
         showComboboxError(field, combobox, message);
      }

      function clearTextfieldError(field, input) {
         var shell = input.closest('.ds-textfield');
         input.removeAttribute('aria-invalid');
         if (shell) {
            shell.classList.remove('ds-textfield--error');
            var errBtn = shell.querySelector('.ds-textfield__error-btn[data-formulario-validation]');
            if (errBtn) errBtn.remove();
         }
         var errMsg = field.querySelector('.ds-field__error[data-formulario-validation]');
         if (errMsg) errMsg.remove();
      }

      function clearComboboxError(field, combobox) {
         if (!combobox) return;
         combobox.classList.remove('ds-combobox--error');
         var errBtn = combobox.querySelector('.ds-textfield__error-btn[data-formulario-validation]');
         if (errBtn) errBtn.remove();
         var trigger = combobox.querySelector('.ds-combobox__trigger');
         if (trigger) trigger.removeAttribute('aria-invalid');
         var errMsg = field.querySelector('.ds-field__error[data-formulario-validation]');
         if (errMsg) errMsg.remove();
      }

      function updateSummaryVisibility() {
         if (!summary) return;
         summary.hidden = !form.querySelector('.ds-field__error[data-formulario-validation]');
      }

      function clearFieldError(field) {
         var input = field.querySelector('.ds-textfield__input');
         if (input) {
            clearTextfieldError(field, input);
            updateSummaryVisibility();
            return;
         }
         var combobox = field.querySelector('[data-combobox-multi]') || field.querySelector('[data-combobox]');
         clearComboboxError(field, combobox);
         updateSummaryVisibility();
      }

      function clearAllErrors() {
         if (summary) summary.hidden = true;
         form.querySelectorAll('.ds-field[data-required]').forEach(function (field) {
            var input = field.querySelector('.ds-textfield__input');
            if (input) clearTextfieldError(field, input);
            else {
               var combobox = field.querySelector('[data-combobox-multi]') || field.querySelector('[data-combobox]');
               clearComboboxError(field, combobox);
            }
         });
      }

      function activateDadosTab() {
         if (!dadosTab || dadosTab.classList.contains('ds-tabs__tab--active')) return;
         dadosTab.click();
      }

      function focusInvalidField(field) {
         var input = field.querySelector('.ds-textfield__input');
         if (input) {
            input.focus();
            return;
         }
         var trigger = field.querySelector('.ds-combobox__trigger');
         if (trigger) trigger.focus();
      }

      function validateForm() {
         clearAllErrors();
         var invalidFields = [];
         form.querySelectorAll('.ds-field[data-required]').forEach(function (field) {
            if (isFieldEmpty(field)) invalidFields.push(field);
         });

         if (!invalidFields.length) return true;

         if (summary) summary.hidden = false;
         invalidFields.forEach(function (field) {
            showFieldError(field, REQUIRED_MSG);
         });
         activateDadosTab();
         focusInvalidField(invalidFields[0]);
         if (summary) summary.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
         return false;
      }

      submitBtn.addEventListener('click', function () {
         if (!validateForm()) return;
         clearAllErrors();
      });

      form.addEventListener('input', function (e) {
         var input = e.target.closest('.ds-textfield__input');
         if (!input) return;
         var field = input.closest('.ds-field[data-required]');
         if (field && !isFieldEmpty(field)) clearFieldError(field);
      });

      form.addEventListener('change', function (e) {
         var checkbox = e.target.closest('.ds-combobox__checkbox-input');
         if (checkbox) {
            var multiField = checkbox.closest('.ds-field[data-required]');
            if (multiField && !isFieldEmpty(multiField)) clearFieldError(multiField);
            return;
         }
         var option = e.target.closest('.ds-combobox__option');
         if (!option) return;
         var comboField = option.closest('.ds-field[data-required]');
         if (comboField && !isFieldEmpty(comboField)) clearFieldError(comboField);
      });

      form.addEventListener('click', function (e) {
         var option = e.target.closest('.ds-combobox__option');
         if (!option || option.closest('[data-combobox-multi]')) return;
         var comboField = option.closest('.ds-field[data-required]');
         if (comboField && !isFieldEmpty(comboField)) clearFieldError(comboField);
      });
   })();

   document.querySelectorAll('[data-mcb-tabs]').forEach(function (root) {
      var tablist = root.querySelector('.ds-tabs');
      if (!tablist) return;
      var tabs = tablist.querySelectorAll('.ds-tabs__tab[data-mcb-tab]');
      var panels = root.querySelectorAll('[data-mcb-panel]');
      tabs.forEach(function (tab) {
         tab.addEventListener('click', function () {
            var key = tab.getAttribute('data-mcb-tab');
            tabs.forEach(function (t) {
               t.classList.remove('ds-tabs__tab--active');
               t.setAttribute('aria-selected', 'false');
            });
            tab.classList.add('ds-tabs__tab--active');
            tab.setAttribute('aria-selected', 'true');
            panels.forEach(function (panel) {
               var isActive = panel.getAttribute('data-mcb-panel') === key;
               if (isActive) {
                  panel.removeAttribute('hidden');
               } else {
                  panel.setAttribute('hidden', '');
               }
            });
         });
      });
   });

   document.querySelectorAll('.ds-tabs').forEach(function (tablist) {
      if (tablist.closest('[data-comp-doc-tabs]') || tablist.closest('[data-mcb-tabs]')) return;
      var tabs = tablist.querySelectorAll('.ds-tabs__tab');
      tabs.forEach(function (tab) {
         tab.addEventListener('click', function () {
            tabs.forEach(function (t) {
               t.classList.remove('ds-tabs__tab--active');
               t.setAttribute('aria-selected', 'false');
            });
            tab.classList.add('ds-tabs__tab--active');
            tab.setAttribute('aria-selected', 'true');
         });
      });
   });

   var DS_FIELD_CALENDAR_ICON_HTML =
      '<svg class="ds-field-calendar-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M6.75 3V5.25M17.25 3V5.25M3 18.75V7.5C3 6.25736 4.00736 5.25 5.25 5.25H18.75C19.9926 5.25 21 6.25736 21 7.5V18.75M3 18.75C3 19.9926 4.00736 21 5.25 21H18.75C19.9926 21 21 19.9926 21 18.75M3 18.75V11.25C3 10.0074 4.00736 9 5.25 9H18.75C19.9926 9 21 10.0074 21 11.25V18.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';

   function ensureFieldCalendarIcon(trigger) {
      if (!trigger) return;
      trigger.innerHTML = DS_FIELD_CALENDAR_ICON_HTML;
   }

   (function initDatePickers() {
      var MONTHS = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
      var MIN_YEAR = 1920;
      var MAX_YEAR = new Date().getFullYear();
      var YEARS_PER_PAGE = 12;
      var popupInstances = [];

      function maskDateInputValue(value) {
         var digits = String(value || '')
            .replace(/\D/g, '')
            .slice(0, 8);
         if (digits.length <= 2) return digits;
         if (digits.length <= 4) return digits.slice(0, 2) + '/' + digits.slice(2);
         return digits.slice(0, 2) + '/' + digits.slice(2, 4) + '/' + digits.slice(4);
      }

      function pad(n) {
         return n < 10 ? '0' + n : String(n);
      }

      function formatDate(day, month, year) {
         return pad(day) + '/' + pad(month + 1) + '/' + year;
      }

      function formatLongDate(day, month, year) {
         return day + ' de ' + MONTHS[month] + ' de ' + year;
      }

      function defaultState() {
         var t = new Date();
         var y = t.getFullYear();
         return {
            day: t.getDate(),
            month: t.getMonth(),
            year: y,
            yearPageStart: Math.floor(y / YEARS_PER_PAGE) * YEARS_PER_PAGE,
         };
      }

      function parseInputToState(value, target, maxYear) {
         var parts = (value || '').split('/');
         if (parts.length !== 3) return false;
         var d = parseInt(parts[0], 10);
         var m = parseInt(parts[1], 10) - 1;
         var y = parseInt(parts[2], 10);
         var yearLimit = typeof maxYear === 'number' ? maxYear : MAX_YEAR;
         if (isNaN(d) || isNaN(m) || isNaN(y)) return false;
         if (m < 0 || m > 11 || y < MIN_YEAR || y > yearLimit) return false;
         var maxDay = new Date(y, m + 1, 0).getDate();
         target.day = Math.min(Math.max(d, 1), maxDay);
         target.month = m;
         target.year = y;
         target.yearPageStart = Math.floor(y / YEARS_PER_PAGE) * YEARS_PER_PAGE;
         return true;
      }

      function getDatepickerPopupInnerHtml() {
         var navPrev =
            '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M14.5 6.5L9 12l5.5 5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
         var navNext =
            '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9.5 6.5L15 12l-5.5 5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
         var yearChevron =
            '<svg class="ds-date-sheet__year-chevron" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
         return (
            '<div class="ds-date-sheet__backdrop" data-popup-close tabindex="-1" aria-hidden="true"></div>' +
            '<div class="ds-date-sheet__panel">' +
            '<div class="ds-date-sheet__head ds-popup__head">' +
            '<h2 class="ds-popup__title">Selecione a data</h2>' +
            '</div>' +
            '<p class="ds-date-sheet__display" data-dp-display></p>' +
            '<div class="ds-date-sheet__cal">' +
            '<div class="ds-datepicker__view" data-dp-view="days">' +
            '<div class="ds-date-sheet__nav-row">' +
            '<div class="ds-date-sheet__month-pill">' +
            '<button type="button" class="ds-date-sheet__pill-nav" data-dp-nav="prev" aria-label="Mês anterior">' +
            navPrev +
            '</button>' +
            '<button type="button" class="ds-date-sheet__month-label" data-dp-open="months">Mês</button>' +
            '<button type="button" class="ds-date-sheet__pill-nav" data-dp-nav="next" aria-label="Próximo mês">' +
            navNext +
            '</button></div>' +
            '<button type="button" class="ds-date-sheet__year-pill" data-dp-open="years" aria-label="Selecionar ano">' +
            '<span data-dp-year-label>Ano</span>' +
            yearChevron +
            '</button></div>' +
            '<ul class="ds-datepicker__weekdays" aria-hidden="true">' +
            '<li>dom</li><li>seg</li><li>ter</li><li>qua</li><li>qui</li><li>sex</li><li>sab</li></ul>' +
            '<ul class="ds-datepicker__days" data-dp-days></ul></div>' +
            '<div class="ds-datepicker__view" data-dp-view="months" hidden>' +
            '<div class="ds-datepicker__header">' +
            '<button type="button" class="ds-datepicker__nav-btn" data-dp-nav="prev" aria-label="Ano anterior">' +
            navPrev +
            '</button>' +
            '<button type="button" class="ds-datepicker__selector ds-datepicker__range-label" data-dp-open="years">Ano</button>' +
            '<button type="button" class="ds-datepicker__nav-btn" data-dp-nav="next" aria-label="Próximo ano">' +
            navNext +
            '</button></div>' +
            '<ul class="ds-datepicker__picker-grid" data-dp-months></ul></div>' +
            '<div class="ds-datepicker__view" data-dp-view="years" hidden>' +
            '<div class="ds-datepicker__header">' +
            '<button type="button" class="ds-datepicker__nav-btn" data-dp-nav="prev" aria-label="Anos anteriores">' +
            navPrev +
            '</button>' +
            '<p class="ds-datepicker__range-label" data-dp-year-range></p>' +
            '<button type="button" class="ds-datepicker__nav-btn" data-dp-nav="next" aria-label="Próximos anos">' +
            navNext +
            '</button></div>' +
            '<ul class="ds-datepicker__picker-grid ds-datepicker__picker-grid--years" data-dp-years></ul></div>' +
            '</div>' +
            '<div class="ds-date-sheet__footer">' +
            '<button type="button" class="ds-btn ds-btn--outline" data-dp-cancel>Cancelar</button>' +
            '<button type="button" class="ds-btn ds-btn--primary" data-dp-confirm>Selecionar</button>' +
            '</div></div>'
         );
      }

      function createDatepickerPopupElement(id, ariaLabel) {
         var popup = document.createElement('div');
         popup.id = id;
         popup.className = 'ds-datepicker-popup ds-date-sheet';
         popup.setAttribute('role', 'dialog');
         popup.setAttribute('aria-modal', 'true');
         popup.setAttribute('aria-label', ariaLabel || 'Selecionar data');
         popup.hidden = true;
         popup.innerHTML = getDatepickerPopupInnerHtml();
         return popup;
      }

      function normalizeDatepickerPopup(popup) {
         if (!popup) return popup;
         if (popup.querySelector('.ds-date-sheet__panel') && popup.querySelector('[data-dp-confirm]')) {
            return popup;
         }
         var id = popup.id;
         var label = popup.getAttribute('aria-label') || 'Selecionar data';
         var next = createDatepickerPopupElement(id, label);
         if (popup.parentNode) popup.parentNode.replaceChild(next, popup);
         return next;
      }

      function ensureDatepickerFieldStructure(textfieldEl) {
         if (textfieldEl.closest('.ds-field--datepicker')) return textfieldEl.closest('.ds-field--datepicker');
         var input = textfieldEl.querySelector('.ds-textfield__input');
         var trigger = textfieldEl.querySelector('.ds-datepicker-trigger');
         if (!input || !trigger) return null;

         var field = document.createElement('div');
         field.className = 'ds-field ds-field--datepicker';
         var parent = textfieldEl.parentNode;
         parent.insertBefore(field, textfieldEl);
         field.appendChild(textfieldEl);

         var popupId = input.id ? input.id + '-popup' : 'ds-dp-' + Date.now();
         var ariaLabel = trigger.getAttribute('aria-label') || 'Selecionar data';
         trigger.setAttribute('aria-expanded', 'false');
         trigger.setAttribute('aria-controls', popupId);
         field.appendChild(createDatepickerPopupElement(popupId, ariaLabel));
         return field;
      }

      function closeOtherPopups(exceptInst) {
         popupInstances.forEach(function (inst) {
            if (inst !== exceptInst && inst.isOpen()) inst.close(true);
         });
      }

      function attachDatepicker(config) {
         var fieldEl = config.fieldEl;
         var container = config.container;
         var trigger = config.trigger;
         var input = config.input;
         var confirmOnSelect = false;
         var maxDateToday = fieldEl.getAttribute('data-dp-max') === 'today';

         function getEffectiveMaxYear() {
            return maxDateToday ? new Date().getFullYear() : MAX_YEAR;
         }

         function isFutureDate(y, m, day) {
            if (!maxDateToday) return false;
            var candidate = new Date(y, m, day);
            candidate.setHours(0, 0, 0, 0);
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            return candidate.getTime() > today.getTime();
         }

         var displayEl = container.querySelector('[data-dp-display]');
         var yearLabelEl = container.querySelector('[data-dp-year-label]');
         var viewDays = container.querySelector('[data-dp-view="days"]');
         var viewMonths = container.querySelector('[data-dp-view="months"]');
         var viewYears = container.querySelector('[data-dp-view="years"]');
         var daysList = container.querySelector('[data-dp-days]');
         var monthsList = container.querySelector('[data-dp-months]');
         var yearsList = container.querySelector('[data-dp-years]');
         var yearRangeLabel = container.querySelector('[data-dp-year-range]');

         if (!viewDays || !daysList) return null;

         var committed = defaultState();
         var draft = defaultState();
         var cal = { view: 'days' };
         var open = false;

         var inst = {
            fieldEl: fieldEl,
            container: container,
            trigger: trigger,
            input: input,
            mode: config.mode,
            isOpen: function () {
               return open;
            },
            open: function () {
               openPicker();
            },
            close: function (revertDraft) {
               closePicker(revertDraft);
            },
            handleEscape: function () {
               if (!open) return false;
               if (cal.view !== 'days') {
                  showView('days');
                  renderDays();
                  return true;
               }
               closePicker(true);
               return true;
            },
         };

         function copyDraftFromCommitted() {
            draft.day = committed.day;
            draft.month = committed.month;
            draft.year = committed.year;
            draft.yearPageStart = committed.yearPageStart;
         }

         function copyCommittedFromDraft() {
            committed.day = draft.day;
            committed.month = draft.month;
            committed.year = draft.year;
            committed.yearPageStart = draft.yearPageStart;
         }

         function syncInput() {
            inst.input.value = formatDate(committed.day, committed.month, committed.year);
         }

         function clampYear(y) {
            return Math.min(getEffectiveMaxYear(), Math.max(MIN_YEAR, y));
         }

         function updateLabels() {
            if (displayEl) {
               displayEl.textContent = formatLongDate(draft.day, draft.month, draft.year);
            }
            container.querySelectorAll('[data-dp-open="months"]').forEach(function (btn) {
               btn.textContent = MONTHS[draft.month];
            });
            if (yearLabelEl) yearLabelEl.textContent = String(draft.year);
            container.querySelectorAll('[data-dp-view="months"] [data-dp-open="years"]').forEach(function (btn) {
               btn.textContent = String(draft.year);
            });
            container.querySelectorAll('[data-dp-view="days"] [data-dp-open="years"]').forEach(function (btn) {
               btn.textContent = String(draft.year);
            });
         }

         function showView(name) {
            cal.view = name;
            if (viewDays) viewDays.hidden = name !== 'days';
            if (viewMonths) viewMonths.hidden = name !== 'months';
            if (viewYears) viewYears.hidden = name !== 'years';
         }

         function renderDays() {
            var firstDay = new Date(draft.year, draft.month, 1).getDay();
            var daysInMonth = new Date(draft.year, draft.month + 1, 0).getDate();
            if (draft.day > daysInMonth) draft.day = daysInMonth;

            var today = new Date();
            today.setHours(0, 0, 0, 0);

            daysList.innerHTML = '';
            var i;
            for (i = 0; i < firstDay; i++) {
               var emptyLi = document.createElement('li');
               emptyLi.className = 'ds-datepicker__day ds-datepicker__day--empty';
               emptyLi.innerHTML = '<button type="button" class="ds-datepicker__day-btn" tabindex="-1" aria-hidden="true"> </button>';
               daysList.appendChild(emptyLi);
            }
            for (i = 1; i <= daysInMonth; i++) {
               var li = document.createElement('li');
               li.className = 'ds-datepicker__day';
               var btn = document.createElement('button');
               btn.type = 'button';
               btn.className = 'ds-datepicker__day-btn';
               btn.textContent = String(i);

               var dayDate = new Date(draft.year, draft.month, i);
               dayDate.setHours(0, 0, 0, 0);
               var isToday = dayDate.getFullYear() === today.getFullYear() && dayDate.getMonth() === today.getMonth() && dayDate.getDate() === today.getDate();

               if (isFutureDate(draft.year, draft.month, i)) {
                  btn.disabled = true;
                  btn.classList.add('ds-datepicker__day-btn--disabled');
                  btn.setAttribute('aria-disabled', 'true');
               } else if (i === draft.day) {
                  btn.classList.add('ds-datepicker__day-btn--selected');
                  btn.setAttribute('aria-pressed', 'true');
               } else {
                  btn.setAttribute('aria-pressed', 'false');
               }

               if (isToday && i !== draft.day) {
                  btn.classList.add('ds-datepicker__day-btn--today');
                  btn.setAttribute('aria-current', 'date');
               }

               if (!btn.disabled) {
                  btn.addEventListener(
                     'click',
                     (function (dayNum) {
                        return function (e) {
                           e.stopPropagation();
                           draft.day = dayNum;
                           updateLabels();
                           renderDays();
                           if (confirmOnSelect) confirmSelection();
                        };
                     })(i)
                  );
               }
               li.appendChild(btn);
               daysList.appendChild(li);
            }
            updateLabels();
         }

         function renderMonths() {
            if (!monthsList) return;
            monthsList.innerHTML = '';
            MONTHS.forEach(function (name, index) {
               var li = document.createElement('li');
               var btn = document.createElement('button');
               btn.type = 'button';
               btn.className = 'ds-datepicker__picker-btn';
               btn.textContent = name;
               if (index === draft.month) {
                  btn.classList.add('ds-datepicker__picker-btn--selected');
               }
               btn.addEventListener(
                  'click',
                  (function (monthIndex) {
                     return function (e) {
                        e.stopPropagation();
                        draft.month = monthIndex;
                        showView('days');
                        renderDays();
                     };
                  })(index)
               );
               li.appendChild(btn);
               monthsList.appendChild(li);
            });
            updateLabels();
         }

         function renderYears() {
            if (!yearsList || !yearRangeLabel) return;
            var start = draft.yearPageStart;
            var end = Math.min(start + YEARS_PER_PAGE - 1, getEffectiveMaxYear());
            yearRangeLabel.textContent = start + ' – ' + end;
            yearsList.innerHTML = '';

            for (var y = start; y <= end; y++) {
               var li = document.createElement('li');
               var btn = document.createElement('button');
               btn.type = 'button';
               btn.className = 'ds-datepicker__picker-btn';
               btn.textContent = String(y);
               if (y === draft.year) {
                  btn.classList.add('ds-datepicker__picker-btn--selected');
               }
               btn.addEventListener(
                  'click',
                  (function (yearVal) {
                     return function (e) {
                        e.stopPropagation();
                        draft.year = yearVal;
                        showView('days');
                        renderDays();
                     };
                  })(y)
               );
               li.appendChild(btn);
               yearsList.appendChild(li);
            }
         }

         function shiftMonth(delta) {
            var m = draft.month + delta;
            var y = draft.year;
            if (m < 0) {
               m = 11;
               y -= 1;
            } else if (m > 11) {
               m = 0;
               y += 1;
            }
            if (y < MIN_YEAR || y > getEffectiveMaxYear()) return;
            draft.month = m;
            draft.year = y;
            renderDays();
         }

         function shiftYear(delta) {
            var y = clampYear(draft.year + delta);
            draft.year = y;
            draft.yearPageStart = Math.floor(y / YEARS_PER_PAGE) * YEARS_PER_PAGE;
            renderMonths();
         }

         function getMaxYearPageStart() {
            var maxYear = getEffectiveMaxYear();
            var start = Math.floor(maxYear / YEARS_PER_PAGE) * YEARS_PER_PAGE;
            if (start + YEARS_PER_PAGE - 1 > maxYear) {
               start = maxYear - YEARS_PER_PAGE + 1;
            }
            return Math.max(MIN_YEAR, start);
         }

         function shiftYearPage(delta) {
            var maxStart = getMaxYearPageStart();
            var next = draft.yearPageStart + delta * YEARS_PER_PAGE;
            if (next < MIN_YEAR || next > maxStart) return;
            draft.yearPageStart = next;
            renderYears();
         }

         function mountPopupToBody() {
            if (!container._dsAnchor) {
               container._dsAnchor = {
                  parent: container.parentNode,
                  next: container.nextSibling,
               };
            }
            if (container.parentNode !== document.body) {
               document.body.appendChild(container);
            }
         }

         function unmountPopupFromBody() {
            var anchor = container._dsAnchor;
            if (anchor && anchor.parent) {
               anchor.parent.insertBefore(container, anchor.next);
            }
         }

         function openPicker() {
            closeOtherPopups(inst);
            if (!parseInputToState(inst.input.value, committed, getEffectiveMaxYear())) {
               committed = defaultState();
            }
            copyDraftFromCommitted();
            showView('days');
            renderDays();
            mountPopupToBody();
            container.removeAttribute('hidden');
            container.hidden = false;
            inst.trigger.setAttribute('aria-expanded', 'true');
            open = true;
            document.body.style.overflow = 'hidden';
         }

         function closePicker(revertDraft) {
            if (revertDraft) copyDraftFromCommitted();
            container.hidden = true;
            container.setAttribute('hidden', '');
            inst.trigger.setAttribute('aria-expanded', 'false');
            open = false;
            document.body.style.overflow = '';
            unmountPopupFromBody();
            showView('days');
         }

         function confirmSelection() {
            copyCommittedFromDraft();
            inst.input.value = formatDate(committed.day, committed.month, committed.year);
            closePicker(false);
         }

         if (!parseInputToState(inst.input.value, committed, getEffectiveMaxYear())) {
            // Se input vazio, não forçar data
            if (inst.input.value.trim() === '') {
               committed = defaultState();
               copyDraftFromCommitted();
               updateLabels();
            } else {
               committed = defaultState();
               copyDraftFromCommitted();
               inst.input.value = formatDate(committed.day, committed.month, committed.year);
               updateLabels();
            }
         } else {
            copyDraftFromCommitted();
            inst.input.value = formatDate(committed.day, committed.month, committed.year);
            updateLabels();
         }

         function togglePickerFromField(e) {
            if (e) {
               e.preventDefault();
               e.stopPropagation();
            }
            if (!inst.isOpen()) openPicker();
            else closePicker(true);
         }

         ensureFieldCalendarIcon(inst.trigger);

         inst.trigger.addEventListener('mousedown', function (e) {
            e.stopPropagation();
         });
         inst.trigger.addEventListener('click', togglePickerFromField);

         if (!inst.input.hasAttribute('readonly') && inst.input.getAttribute('aria-readonly') !== 'true') {
            inst.input.addEventListener('input', function () {
               inst.input.value = maskDateInputValue(inst.input.value);
            });
            inst.input.addEventListener('blur', function () {
               if (parseInputToState(inst.input.value, committed, getEffectiveMaxYear())) {
                  copyDraftFromCommitted();
               }
            });
         }

         container.addEventListener('mousedown', function (e) {
            e.stopPropagation();
         });

         container.querySelectorAll('[data-popup-close]').forEach(function (el) {
            el.addEventListener('click', function () {
               closePicker(true);
            });
         });

         var cancelBtn = container.querySelector('[data-dp-cancel]');
         if (cancelBtn) {
            cancelBtn.addEventListener('click', function () {
               closePicker(true);
            });
         }

         var confirmBtn = container.querySelector('[data-dp-confirm]');
         if (confirmBtn) {
            confirmBtn.addEventListener('click', function () {
               confirmSelection();
            });
         }

         container.querySelectorAll('[data-dp-open]').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
               e.stopPropagation();
               var target = btn.getAttribute('data-dp-open');
               if (target === 'months') {
                  showView('months');
                  renderMonths();
               } else if (target === 'years') {
                  draft.yearPageStart = Math.floor(draft.year / YEARS_PER_PAGE) * YEARS_PER_PAGE;
                  showView('years');
                  renderYears();
               }
            });
         });

         container.querySelectorAll('[data-dp-nav]').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
               e.stopPropagation();
               var dir = btn.getAttribute('data-dp-nav') === 'next' ? 1 : -1;
               if (cal.view === 'days') shiftMonth(dir);
               else if (cal.view === 'months') shiftYear(dir);
               else if (cal.view === 'years') shiftYearPage(dir);
            });
         });

         container.addEventListener('click', function (e) {
            e.stopPropagation();
         });

         return inst;
      }

      function initPopupFields(root) {
         var scope = root && root.querySelectorAll ? root : document;
         scope.querySelectorAll('.ds-textfield--datepicker').forEach(function (tf) {
            ensureDatepickerFieldStructure(tf);
         });

         scope.querySelectorAll('.ds-field--datepicker').forEach(function (fieldEl) {
            if (fieldEl.getAttribute('data-ds-datepicker-init') === 'true') return;

            var trigger = fieldEl.querySelector('.ds-datepicker-trigger');
            var input = fieldEl.querySelector('.ds-textfield__input');
            if (!trigger || !input) return;

            var controlsId = trigger.getAttribute('aria-controls');
            var container = fieldEl.querySelector('.ds-datepicker-popup');
            if (!container && controlsId) {
               container = document.getElementById(controlsId);
            }
            if (!container) {
               var popupId = input.id ? input.id + '-popup' : 'ds-dp-' + Date.now();
               var ariaLabel = trigger.getAttribute('aria-label') || 'Selecionar data';
               container = createDatepickerPopupElement(popupId, ariaLabel);
               fieldEl.appendChild(container);
               trigger.setAttribute('aria-controls', popupId);
               trigger.setAttribute('aria-expanded', 'false');
            }
            if (!container) return;
            container = normalizeDatepickerPopup(container);

            var inst = attachDatepicker({
               fieldEl: fieldEl,
               container: container,
               trigger: trigger,
               input: input,
               mode: 'popup',
            });
            if (!inst) return;
            fieldEl.setAttribute('data-ds-datepicker-init', 'true');
            popupInstances.push(inst);
         });
      }

      initPopupFields();

      window.__dsInitDatepickerFields = initPopupFields;
      window.__dsIsDatepickerOpen = function () {
         return popupInstances.some(function (inst) {
            return inst.isOpen();
         });
      };

      document.addEventListener('click', function (e) {
         popupInstances.forEach(function (inst) {
            if (!inst.isOpen()) return;
            if (inst.trigger.contains(e.target)) return;
            if (inst.fieldEl && inst.fieldEl.contains(e.target)) return;
            if (inst.container.contains(e.target)) return;
            inst.close(true);
         });
      });

      document.addEventListener('keydown', function (e) {
         if (e.key !== 'Escape') return;
         popupInstances.forEach(function (inst) {
            if (inst.mode === 'popup') inst.handleEscape();
         });
      });
   })();

   (function initPeriodPicker() {
      var field = document.querySelector('.ds-field--period');
      var sheet = document.getElementById('ds-period-sheet');
      if (!field || !sheet) return;

      var trigger = field.querySelector('.ds-period-trigger');
      var input = field.querySelector('#ds-periodo');
      if (!trigger || !input) return;

      var MONTHS = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
      var MIN_YEAR = 1920;
      var MAX_YEAR = new Date().getFullYear() + 10;
      var YEARS_PER_PAGE = 12;

      var fromEl = sheet.querySelector('[data-period-from]');
      var toEl = sheet.querySelector('[data-period-to]');
      var viewDays = sheet.querySelector('[data-period-view="days"]');
      var viewMonths = sheet.querySelector('[data-period-view="months"]');
      var viewYears = sheet.querySelector('[data-period-view="years"]');
      var daysList = sheet.querySelector('[data-period-days]');
      var monthsList = sheet.querySelector('[data-period-months]');
      var yearsList = sheet.querySelector('[data-period-years]');
      var yearRangeLabel = sheet.querySelector('[data-period-year-range]');

      function dateKey(d) {
         return d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate();
      }

      function pad(n) {
         return n < 10 ? '0' + n : String(n);
      }

      function formatDate(d) {
         return pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + d.getFullYear();
      }

      function parseDate(str) {
         var parts = (str || '').trim().split('/');
         if (parts.length !== 3) return null;
         var day = parseInt(parts[0], 10);
         var month = parseInt(parts[1], 10) - 1;
         var year = parseInt(parts[2], 10);
         if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
         if (month < 0 || month > 11) return null;
         var maxDay = new Date(year, month + 1, 0).getDate();
         day = Math.min(Math.max(day, 1), maxDay);
         return new Date(year, month, day);
      }

      function parseInputRange() {
         var raw = (input.value || '').trim();
         if (!raw) return { start: null, end: null };
         var sep = raw.indexOf('–') >= 0 ? '–' : raw.indexOf('-') >= 0 ? '-' : null;
         if (!sep) return { start: null, end: null };
         var parts = raw.split(sep);
         if (parts.length < 2) return { start: null, end: null };
         return {
            start: parseDate(parts[0]),
            end: parseDate(parts[1]),
         };
      }

      var committed = { start: null, end: null };
      var draft = { start: null, end: null };
      var cal = {
         view: 'days',
         month: 4,
         year: 2026,
         yearPageStart: 2020,
      };

      function syncCommittedFromInput() {
         var parsed = parseInputRange();
         committed.start = parsed.start;
         committed.end = parsed.end;
      }

      function formatRangeInput(start, end) {
         if (!start) return '';
         if (!end) return formatDate(start);
         return formatDate(start) + ' – ' + formatDate(end);
      }

      function cloneDate(d) {
         return d ? new Date(d.getTime()) : null;
      }

      function copyDraftFromCommitted() {
         draft.start = cloneDate(committed.start);
         draft.end = cloneDate(committed.end);
         if (draft.start) {
            cal.month = draft.start.getMonth();
            cal.year = draft.start.getFullYear();
            cal.yearPageStart = Math.floor(cal.year / YEARS_PER_PAGE) * YEARS_PER_PAGE;
         }
      }

      function updateBounds() {
         fromEl.textContent = draft.start ? formatDate(draft.start) : '—';
         toEl.textContent = draft.end ? formatDate(draft.end) : '—';
      }

      function showView(name) {
         cal.view = name;
         viewDays.hidden = name !== 'days';
         viewMonths.hidden = name !== 'months';
         viewYears.hidden = name !== 'years';
      }

      function updateMonthYearLabels() {
         sheet.querySelectorAll('[data-period-open="months"]').forEach(function (btn) {
            btn.textContent = MONTHS[cal.month];
         });
         sheet.querySelectorAll('[data-period-open="years"]').forEach(function (btn) {
            btn.textContent = String(cal.year);
         });
      }

      function compareDates(a, b) {
         return a.getTime() - b.getTime();
      }

      function normalizeRange() {
         if (draft.start && draft.end && compareDates(draft.start, draft.end) > 0) {
            var tmp = draft.start;
            draft.start = draft.end;
            draft.end = tmp;
         }
      }

      function isInRange(dayDate) {
         if (!draft.start) return false;
         if (!draft.end) {
            return dateKey(dayDate) === dateKey(draft.start);
         }
         return compareDates(dayDate, draft.start) >= 0 && compareDates(dayDate, draft.end) <= 0;
      }

      function isSameCalendarDay(a, b) {
         return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
      }

      function renderDays() {
         var firstDay = new Date(cal.year, cal.month, 1).getDay();
         var daysInMonth = new Date(cal.year, cal.month + 1, 0).getDate();
         var today = new Date();
         today.setHours(0, 0, 0, 0);
         daysList.innerHTML = '';
         updateMonthYearLabels();

         var i;
         for (i = 0; i < firstDay; i++) {
            var emptyLi = document.createElement('li');
            emptyLi.className = 'ds-datepicker__day ds-datepicker__day--empty';
            emptyLi.innerHTML = '<button type="button" class="ds-datepicker__day-btn" tabindex="-1" aria-hidden="true"> </button>';
            daysList.appendChild(emptyLi);
         }

         for (i = 1; i <= daysInMonth; i++) {
            var dayDate = new Date(cal.year, cal.month, i);
            dayDate.setHours(0, 0, 0, 0);
            var li = document.createElement('li');
            li.className = 'ds-datepicker__day';
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'ds-datepicker__day-btn';
            btn.textContent = String(i);

            var dow = dayDate.getDay();
            var inRange = isInRange(dayDate);
            var isStart = draft.start && dateKey(dayDate) === dateKey(draft.start);
            var isEnd = draft.end && dateKey(dayDate) === dateKey(draft.end);
            var isToday = isSameCalendarDay(dayDate, today);
            var singleDay = draft.start && draft.end && dateKey(draft.start) === dateKey(draft.end);

            if (isToday) {
               btn.classList.add('ds-datepicker__day-btn--today');
               btn.setAttribute('aria-current', 'date');
            }

            if (draft.end && inRange && !singleDay) {
               if (!isStart && !isEnd) li.classList.add('ds-datepicker__day--range-in');
               if (isStart) li.classList.add('ds-datepicker__day--range-start');
               if (isEnd) li.classList.add('ds-datepicker__day--range-end');
               if (dow === 0 || isStart) li.classList.add('ds-datepicker__day--range-row-start');
               if (dow === 6 || isEnd) li.classList.add('ds-datepicker__day--range-row-end');
            }

            if (isStart) btn.classList.add('ds-datepicker__day-btn--range-start');
            if (isEnd) btn.classList.add('ds-datepicker__day-btn--range-end');

            btn.addEventListener(
               'click',
               (function (clicked) {
                  return function () {
                     if (!draft.start || (draft.start && draft.end)) {
                        draft.start = clicked;
                        draft.end = null;
                     } else if (compareDates(clicked, draft.start) < 0) {
                        draft.end = draft.start;
                        draft.start = clicked;
                     } else {
                        draft.end = clicked;
                     }
                     normalizeRange();
                     updateBounds();
                     renderDays();
                  };
               })(dayDate)
            );

            li.appendChild(btn);
            daysList.appendChild(li);
         }
      }

      function renderMonths() {
         monthsList.innerHTML = '';
         MONTHS.forEach(function (name, index) {
            var li = document.createElement('li');
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'ds-datepicker__picker-btn';
            btn.textContent = name;
            if (index === cal.month) btn.classList.add('ds-datepicker__picker-btn--selected');
            btn.addEventListener(
               'click',
               (function (monthIndex) {
                  return function () {
                     cal.month = monthIndex;
                     showView('days');
                     renderDays();
                  };
               })(index)
            );
            li.appendChild(btn);
            monthsList.appendChild(li);
         });
         updateMonthYearLabels();
      }

      function renderYears() {
         var start = cal.yearPageStart;
         var end = Math.min(start + YEARS_PER_PAGE - 1, MAX_YEAR);
         yearRangeLabel.textContent = start + ' – ' + end;
         yearsList.innerHTML = '';

         for (var y = start; y <= end; y++) {
            var li = document.createElement('li');
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'ds-datepicker__picker-btn';
            btn.textContent = String(y);
            if (y === cal.year) btn.classList.add('ds-datepicker__picker-btn--selected');
            btn.addEventListener(
               'click',
               (function (yearVal) {
                  return function () {
                     cal.year = yearVal;
                     showView('days');
                     renderDays();
                  };
               })(y)
            );
            li.appendChild(btn);
            yearsList.appendChild(li);
         }
      }

      function openSheet() {
         copyDraftFromCommitted();
         showView('days');
         updateBounds();
         renderDays();
         sheet.hidden = false;
         trigger.setAttribute('aria-expanded', 'true');
         document.body.style.overflow = 'hidden';
      }

      function closeSheet(revertDraft) {
         if (revertDraft) copyDraftFromCommitted();
         sheet.hidden = true;
         trigger.setAttribute('aria-expanded', 'false');
         document.body.style.overflow = '';
      }

      function confirmSelection() {
         if (!draft.start) return;
         committed.start = cloneDate(draft.start);
         committed.end = cloneDate(draft.end);
         input.value = formatRangeInput(committed.start, committed.end);
         closeSheet(false);
      }

      syncCommittedFromInput();

      ensureFieldCalendarIcon(trigger);

      trigger.addEventListener('click', function (e) {
         e.stopPropagation();
         if (sheet.hidden) openSheet();
         else closeSheet(true);
      });

      if (!input.hasAttribute('readonly') && input.getAttribute('aria-readonly') !== 'true') {
         input.addEventListener('blur', function () {
            syncCommittedFromInput();
         });
      }

      sheet.querySelectorAll('[data-popup-close]').forEach(function (el) {
         el.addEventListener('click', function () {
            closeSheet(true);
         });
      });

      sheet.querySelector('[data-period-cancel]').addEventListener('click', function () {
         closeSheet(true);
      });

      sheet.querySelector('[data-period-confirm]').addEventListener('click', function () {
         confirmSelection();
      });

      sheet.querySelectorAll('[data-period-open]').forEach(function (btn) {
         btn.addEventListener('click', function () {
            var target = btn.getAttribute('data-period-open');
            if (target === 'months') {
               showView('months');
               renderMonths();
            } else if (target === 'years') {
               showView('years');
               renderYears();
            }
         });
      });

      sheet.querySelectorAll('[data-period-nav]').forEach(function (btn) {
         btn.addEventListener('click', function () {
            var dir = btn.getAttribute('data-period-nav');
            var delta = dir === 'prev' ? -1 : 1;
            if (cal.view === 'days') {
               cal.month += delta;
               if (cal.month < 0) {
                  cal.month = 11;
                  cal.year -= 1;
               } else if (cal.month > 11) {
                  cal.month = 0;
                  cal.year += 1;
               }
               renderDays();
            } else if (cal.view === 'months') {
               cal.year += delta;
               renderMonths();
            } else if (cal.view === 'years') {
               cal.yearPageStart += delta * YEARS_PER_PAGE;
               cal.yearPageStart = Math.max(MIN_YEAR, Math.min(cal.yearPageStart, MAX_YEAR - YEARS_PER_PAGE + 1));
               renderYears();
            }
         });
      });

      document.addEventListener('keydown', function (e) {
         if (e.key !== 'Escape' || sheet.hidden) return;
         if (cal.view !== 'days') {
            showView('days');
            renderDays();
         } else {
            closeSheet(true);
         }
      });
   })();

   document.querySelectorAll('.ds-segmented').forEach(function (group) {
      var options = group.querySelectorAll('.ds-segmented__option');
      options.forEach(function (option) {
         option.addEventListener('click', function () {
            options.forEach(function (o) {
               o.classList.remove('ds-segmented__option--active');
               o.setAttribute('aria-pressed', 'false');
            });
            option.classList.add('ds-segmented__option--active');
            option.setAttribute('aria-pressed', 'true');
         });
      });
   });

   document.querySelectorAll('[data-slider]').forEach(function (wrap) {
      var input = wrap.querySelector('.ds-slider__input');
      if (!input) return;

      function updateFill() {
         var min = Number(input.min) || 0;
         var max = Number(input.max) || 100;
         var val = Number(input.value);
         var range = max - min || 1;
         var pct = ((val - min) / range) * 100 + '%';
         wrap.style.setProperty('--ds-slider-fill', pct);
      }

      input.addEventListener('input', updateFill);
      updateFill();
   });

   document.querySelectorAll('[data-dot-nav]').forEach(function (nav) {
      var dots = nav.querySelectorAll('.ds-dot-nav__dot');
      var prevBtn = nav.querySelector('.ds-dot-nav__chevron--prev');
      var nextBtn = nav.querySelector('.ds-dot-nav__chevron--next');
      if (!dots.length) return;

      var carousel = nav.closest('[data-404-carousel]');
      var slides = carousel ? carousel.querySelectorAll('.ds-template-404__carousel-slide') : [];

      var current = 0;
      dots.forEach(function (dot, index) {
         if (dot.classList.contains('ds-dot-nav__dot--active')) current = index;
      });

      function updateChevrons() {
         if (prevBtn) {
            prevBtn.disabled = current === 0;
         }
         if (nextBtn) {
            nextBtn.disabled = current === dots.length - 1;
         }
      }

      function setActive(index) {
         current = Math.max(0, Math.min(index, dots.length - 1));
         dots.forEach(function (dot, i) {
            var isActive = i === current;
            dot.classList.toggle('ds-dot-nav__dot--active', isActive);
            if (isActive) {
               dot.setAttribute('aria-current', 'true');
            } else {
               dot.removeAttribute('aria-current');
            }
         });
         slides.forEach(function (slide, i) {
            var isActive = i === current;
            slide.hidden = !isActive;
            slide.classList.toggle('is-active', isActive);
         });
         updateChevrons();
      }

      dots.forEach(function (dot, index) {
         dot.addEventListener('click', function () {
            setActive(index);
         });
      });

      if (prevBtn) {
         prevBtn.addEventListener('click', function () {
            setActive(current - 1);
         });
      }

      if (nextBtn) {
         nextBtn.addEventListener('click', function () {
            setActive(current + 1);
         });
      }

      setActive(current);
   });

   document.querySelectorAll('[data-combobox-multi]').forEach(function (root) {
      var wrap = root.closest('.ds-combobox-multi');
      var trigger = root.querySelector('.ds-combobox__trigger');
      var menu = root.querySelector('.ds-combobox__menu');
      var tagsEl = wrap && wrap.querySelector('[data-combobox-tags]');
      var checkboxes = root.querySelectorAll('.ds-combobox__checkbox-input');
      if (!trigger || !tagsEl || !menu) return;

      function setOpen(open) {
         root.classList.toggle('is-open', open);
         trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      function renderTags() {
         tagsEl.innerHTML = '';
         checkboxes.forEach(function (cb) {
            if (!cb.checked) return;
            var tag = document.createElement('span');
            tag.className = 'ds-combobox__tag';
            var text = document.createElement('span');
            text.className = 'ds-combobox__tag-text';
            text.textContent = cb.value;
            var removeBtn = document.createElement('button');
            removeBtn.type = 'button';
            removeBtn.className = 'ds-combobox__tag-remove';
            removeBtn.setAttribute('aria-label', 'Remover ' + cb.value);
            removeBtn.textContent = '×';
            removeBtn.addEventListener('click', function (e) {
               e.stopPropagation();
               cb.checked = false;
               renderTags();
            });
            tag.appendChild(text);
            tag.appendChild(removeBtn);
            tagsEl.appendChild(tag);
         });
      }

      trigger.addEventListener('click', function (e) {
         e.stopPropagation();
         setOpen(!root.classList.contains('is-open'));
      });

      menu.addEventListener('click', function (e) {
         e.stopPropagation();
      });

      checkboxes.forEach(function (cb) {
         cb.addEventListener('change', function () {
            renderTags();
         });
      });

      document.addEventListener('click', function () {
         setOpen(false);
      });

      renderTags();
   });

   document.querySelectorAll('[data-combobox]').forEach(function (root) {
      var trigger = root.querySelector('.ds-combobox__trigger');
      var valueEl = root.querySelector('[data-combobox-value]');
      var options = root.querySelectorAll('.ds-combobox__option');
      if (!trigger || !valueEl) return;

      function setOpen(open) {
         root.classList.toggle('is-open', open);
         trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      trigger.addEventListener('click', function (e) {
         e.stopPropagation();
         setOpen(!root.classList.contains('is-open'));
      });

      options.forEach(function (option) {
         option.addEventListener('click', function (e) {
            e.stopPropagation();
            valueEl.textContent = option.textContent.trim();
            options.forEach(function (o) {
               o.setAttribute('aria-selected', 'false');
            });
            option.setAttribute('aria-selected', 'true');
            setOpen(false);
         });
      });

      document.addEventListener('click', function () {
         setOpen(false);
      });
   });

   function getPaginationPageItems(current, total) {
      if (total <= 7) {
         return Array.from({ length: total }, function (_, i) {
            return { type: 'page', value: i + 1 };
         });
      }

      var pages = new Set();
      pages.add(1);
      pages.add(total);

      if (current <= 4) {
         for (var early = 1; early <= Math.min(4, total); early++) {
            pages.add(early);
         }
      } else if (current >= total - 3) {
         for (var late = Math.max(1, total - 3); late <= total; late++) {
            pages.add(late);
         }
      } else {
         pages.add(current - 1);
         pages.add(current);
         pages.add(current + 1);
      }

      var sorted = Array.from(pages).sort(function (a, b) {
         return a - b;
      });
      var items = [];

      sorted.forEach(function (page, index) {
         if (index > 0 && page - sorted[index - 1] > 1) {
            items.push({ type: 'ellipsis' });
         }
         items.push({ type: 'page', value: page });
      });

      return items;
   }

   function normalizePaginationChevrons(nav) {
      if (!nav || !nav.classList.contains('ds-pagination')) return;
      nav.querySelectorAll('.ds-pagination__chevron > g').forEach(function (g) {
         g.removeAttribute('transform');
      });
   }

   function bindPaginationNav(nav, getState, setPage) {
      normalizePaginationChevrons(nav);
      var pagesEl = nav.querySelector('[data-pagination-pages]');
      var prevBtn = nav.querySelector('[data-pagination-prev]');
      var nextBtn = nav.querySelector('[data-pagination-next]');
      if (!pagesEl || !prevBtn || !nextBtn) return;

      function renderNav() {
         var state = getState();
         var current = state.current;
         var total = state.total;

         pagesEl.innerHTML = '';
         getPaginationPageItems(current, total).forEach(function (item) {
            if (item.type === 'ellipsis') {
               var ellipsis = document.createElement('span');
               ellipsis.className = 'ds-pagination__ellipsis';
               ellipsis.textContent = '...';
               ellipsis.setAttribute('aria-hidden', 'true');
               pagesEl.appendChild(ellipsis);
               return;
            }

            var pageBtn = document.createElement('button');
            pageBtn.type = 'button';
            pageBtn.className = 'ds-pagination__page';
            pageBtn.textContent = String(item.value);
            pageBtn.setAttribute('aria-label', 'Ir para página ' + item.value);

            if (item.value === current) {
               pageBtn.classList.add('ds-pagination__page--active');
               pageBtn.setAttribute('aria-current', 'page');
            } else {
               pageBtn.addEventListener('click', function () {
                  setPage(item.value);
               });
            }

            pagesEl.appendChild(pageBtn);
         });

         prevBtn.disabled = current <= 1;
         nextBtn.disabled = current >= total;
         nav.hidden = total <= 1;
      }

      if (!nav.dataset.paginationBound) {
         nav.dataset.paginationBound = 'true';
         prevBtn.addEventListener('click', function () {
            var state = getState();
            if (state.current > 1) setPage(state.current - 1);
         });

         nextBtn.addEventListener('click', function () {
            var state = getState();
            if (state.current < state.total) setPage(state.current + 1);
         });
      }

      renderNav();
      return renderNav;
   }

   document.querySelectorAll('[data-pagination-demo]').forEach(function (nav) {
      var currentPage = 1;
      var totalPages = 20;
      var renderNav;

      renderNav = bindPaginationNav(
         nav,
         function () {
            return { current: currentPage, total: totalPages };
         },
         function (page) {
            currentPage = page;
            renderNav();
         }
      );
   });

   document.querySelectorAll('[data-icon-pagination]').forEach(function (root) {
      var grid = root.querySelector('.ds-icon-pagination__grid');
      var nav = root.querySelector('[data-pagination]');
      if (!grid || !nav) return;

      var cards = Array.prototype.slice.call(grid.querySelectorAll('.ds-icon-card'));
      var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 12;
      var currentPage = 1;
      var renderNav;

      function getVisibleCards() {
         return cards.filter(function (card) {
            return !card.classList.contains('ds-icon-search__hidden');
         });
      }

      function getTotalPages() {
         return Math.max(1, Math.ceil(getVisibleCards().length / perPage));
      }

      function applyIconPage(page) {
         var visibleCards = getVisibleCards();
         var total = getTotalPages();
         currentPage = Math.min(Math.max(1, page), total);
         var start = (currentPage - 1) * perPage;
         var end = start + perPage;

         cards.forEach(function (card) {
            if (card.classList.contains('ds-icon-search__hidden')) {
               card.classList.add('ds-icon-pagination__hidden');
               return;
            }
            var index = visibleCards.indexOf(card);
            card.classList.toggle('ds-icon-pagination__hidden', index === -1 || index < start || index >= end);
         });

         root.classList.toggle('ds-icon-pagination--search-empty', visibleCards.length === 0);
         renderNav();
      }

      renderNav = bindPaginationNav(
         nav,
         function () {
            return { current: currentPage, total: getTotalPages() };
         },
         applyIconPage
      );

      root._iconPaginationApplyPage = applyIconPage;
      applyIconPage(1);
   });

   (function initIconsPageSearch() {
      if (document.body.getAttribute('data-ds-page') !== 'icones') return;

      var searchInput = document.getElementById('dsIconsSearch');
      var searchClear = document.getElementById('dsIconsSearchClear');
      var searchEmpty = document.getElementById('dsIconsSearchEmpty');
      var searchWrap = document.getElementById('dsIconsSearchWrap');
      if (!searchInput) return;

      var cards = Array.prototype.slice.call(document.querySelectorAll('.ds-icon-card'));
      var totalIcons = cards.length;

      if (searchWrap) {
         searchWrap.setAttribute('data-icons-total', String(totalIcons));
      }

      searchInput.placeholder = 'Buscar entre ' + totalIcons + ' ícones\u2026';
      searchInput.setAttribute('aria-label', 'Buscar entre ' + totalIcons + ' ícones');

      function normalizeIconsQuery(value) {
         return (value || '')
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .trim();
      }

      function getIconCardSearchText(card) {
         var stored = card.getAttribute('data-icon-search');
         if (stored) return stored;
         var nameEl = card.querySelector('.ds-icon-card__name');
         var metaEl = card.querySelector('.ds-icon-card__meta');
         var text = [
            card.getAttribute('data-icon-id') || '',
            card.getAttribute('data-icon-file') || '',
            nameEl ? nameEl.textContent : '',
            metaEl ? metaEl.textContent : '',
         ]
            .join(' ')
            .trim();
         card.setAttribute('data-icon-search', text);
         return text;
      }

      cards.forEach(function (card) {
         getIconCardSearchText(card);
      });

      function refreshIconPagination(hasQuery) {
         document.querySelectorAll('[data-icon-pagination]').forEach(function (root) {
            var nav = root.querySelector('[data-pagination]');

            if (hasQuery) {
               root.querySelectorAll('.ds-icon-card').forEach(function (card) {
                  if (!card.classList.contains('ds-icon-search__hidden')) {
                     card.classList.remove('ds-icon-pagination__hidden');
                  }
               });
               if (nav) nav.hidden = true;
               return;
            }

            if (typeof root._iconPaginationApplyPage === 'function') {
               root._iconPaginationApplyPage(1);
            }
         });
      }

      function setSectionSearchHidden(section, hidden) {
         if (!section) return;
         section.classList.toggle('ds-section--icons-search-hidden', hidden);
      }

      function filterIconsPage() {
         var query = normalizeIconsQuery(searchInput.value);
         var hasQuery = query.length > 0;
         var visibleCount = 0;

         if (searchClear) searchClear.hidden = !hasQuery;

         cards.forEach(function (card) {
            var match = !hasQuery || normalizeIconsQuery(getIconCardSearchText(card)).indexOf(query) !== -1;
            card.classList.toggle('ds-icon-search__hidden', !match);
            if (match) visibleCount++;
         });

         var anyVisible = visibleCount > 0;

         document.body.classList.toggle('ds-icons-page--search-active', hasQuery);
         document.body.classList.toggle('ds-icons-page--no-results', hasQuery && !anyVisible);

         document.querySelectorAll('.ds-icon-library-group').forEach(function (group) {
            var visibleInGroup = group.querySelectorAll('.ds-icon-card:not(.ds-icon-search__hidden)');
            group.classList.toggle('ds-icon-library-group--search-empty', hasQuery && visibleInGroup.length === 0);
         });

         var sectionOutros = document.getElementById('outros-icones');

         if (sectionOutros) {
            var visibleInOutros = sectionOutros.querySelectorAll('.ds-icon-card:not(.ds-icon-search__hidden)');
            setSectionSearchHidden(sectionOutros, hasQuery && visibleInOutros.length === 0);
         }

         refreshIconPagination(hasQuery);

         if (searchEmpty) searchEmpty.hidden = !hasQuery || anyVisible;
      }

      function clearIconsPageSearch() {
         searchInput.value = '';
         filterIconsPage();
         searchInput.focus();
      }

      searchInput.addEventListener('input', filterIconsPage);
      searchInput.addEventListener('search', filterIconsPage);

      if (searchClear) {
         searchClear.addEventListener('click', clearIconsPageSearch);
      }

      searchInput.addEventListener('keydown', function (e) {
         if (e.key === 'Escape') {
            clearIconsPageSearch();
         }
      });
   })();

   function setPasswordFieldVisible(field, visible) {
      if (!field) return;
      var input = field.querySelector('.ds-textfield__input');
      var toggle = field.querySelector('[data-password-toggle]');
      if (!input || !toggle) return;
      field.classList.toggle('is-password-visible', visible);
      input.type = visible ? 'text' : 'password';
      toggle.setAttribute('aria-pressed', visible ? 'true' : 'false');
      toggle.setAttribute('aria-label', visible ? 'Ocultar senha' : 'Exibir senha');
   }

   document.querySelectorAll('[data-password-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
         var field = btn.closest('.ds-textfield--password');
         if (!field) return;
         var visible = field.classList.contains('is-password-visible');
         setPasswordFieldVisible(field, !visible);
      });
   });

   document.querySelectorAll('.ds-card-ui__form').forEach(function (form) {
      form.addEventListener('reset', function () {
         window.setTimeout(function () {
            form.querySelectorAll('.ds-textfield--password').forEach(function (field) {
               setPasswordFieldVisible(field, false);
            });
         }, 0);
      });
   });

   function parseTabelaCardCellValue(text, colIndex) {
      var raw = (text || '').trim();
      if (!raw) return 0;
      if (colIndex === 0) {
         return parseInt(raw, 10) || 0;
      }
      if (colIndex === 3) {
         var parts = raw.split('/');
         if (parts.length === 3) {
            return parseInt(parts[2], 10) * 10000 + parseInt(parts[1], 10) * 100 + parseInt(parts[0], 10);
         }
         return 0;
      }
      if (colIndex === 5) {
         return parseFloat(raw.replace(',', '.')) || 0;
      }
      var normalized = raw.replace(/[^\d,.-]/g, '');
      if (normalized.indexOf(',') >= 0) {
         normalized = normalized.replace(/\./g, '').replace(',', '.');
      }
      return parseFloat(normalized) || 0;
   }

   document.querySelectorAll('[data-tabela-card]').forEach(function (table) {
      var body = table.querySelector('.ds-tabela-card__body');
      var header = table.querySelector('.ds-tabela-card__header');
      if (!body || !header) return;

      var sortState = { col: -1, dir: 'asc' };

      table.querySelectorAll('.ds-tabela-card__sort').forEach(function (sortBtn) {
         sortBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var colHeader = sortBtn.closest('.ds-tabela-card__cell--columnheader');
            if (!colHeader) return;

            var colIndex = Array.prototype.indexOf.call(header.children, colHeader);
            if (colIndex < 0) return;

            if (sortState.col === colIndex) {
               sortState.dir = sortState.dir === 'asc' ? 'desc' : 'asc';
            } else {
               sortState.col = colIndex;
               sortState.dir = 'asc';
            }

            var items = Array.prototype.slice.call(body.querySelectorAll(':scope > li'));
            var rows = items.map(function (li) {
               var row = li.querySelector('.ds-tabela-card__row');
               var cells = row ? row.querySelectorAll('.ds-tabela-card__cell') : [];
               var cellText = cells[colIndex] && cells[colIndex].textContent ? cells[colIndex].textContent : '';
               return {
                  li: li,
                  value: parseTabelaCardCellValue(cellText, colIndex),
               };
            });

            rows.sort(function (a, b) {
               if (a.value < b.value) return sortState.dir === 'asc' ? -1 : 1;
               if (a.value > b.value) return sortState.dir === 'asc' ? 1 : -1;
               return 0;
            });

            rows.forEach(function (entry) {
               body.appendChild(entry.li);
            });

            table.querySelectorAll('.ds-tabela-card__sort').forEach(function (btn) {
               btn.removeAttribute('aria-sort');
            });
            sortBtn.setAttribute('aria-sort', sortState.dir === 'asc' ? 'ascending' : 'descending');
         });
      });
   });

   (function initDsModals() {
      var modalScrollLockCount = 0;

      function lockPageScroll() {
         if (modalScrollLockCount === 0) {
            document.body.style.overflow = 'hidden';
         }
         modalScrollLockCount += 1;
      }

      function unlockPageScroll() {
         modalScrollLockCount = Math.max(0, modalScrollLockCount - 1);
         if (modalScrollLockCount === 0) {
            document.body.style.overflow = '';
         }
      }

      function openDsModal(modal) {
         lockPageScroll();
         modal.hidden = false;
         modal.classList.remove('ds-modal--open');
         requestAnimationFrame(function () {
            requestAnimationFrame(function () {
               modal.classList.add('ds-modal--open');
            });
         });
      }

      function closeDsModal(modal) {
         if (!modal.classList.contains('ds-modal--open')) {
            modal.hidden = true;
            unlockPageScroll();
            return;
         }

         modal.classList.remove('ds-modal--open');
         var panel = modal.querySelector('.ds-modal__panel');
         var finished = false;

         function finish() {
            if (finished) return;
            finished = true;
            modal.hidden = true;
            unlockPageScroll();
            if (panel) {
               panel.removeEventListener('transitionend', onTransitionEnd);
            }
         }

         function onTransitionEnd(event) {
            if (event.target !== panel) return;
            if (event.propertyName !== 'opacity' && event.propertyName !== 'transform') return;
            finish();
         }

         if (panel) {
            panel.addEventListener('transitionend', onTransitionEnd);
         }
         window.setTimeout(finish, 320);
      }

      document.querySelectorAll('[data-modal-open]').forEach(function (trigger) {
         trigger.addEventListener('click', function () {
            var selector = trigger.getAttribute('data-modal-open');
            if (!selector) return;
            var modal = document.querySelector(selector);
            if (modal) openDsModal(modal);
         });
      });

      document.querySelectorAll('.ds-modal').forEach(function (modal) {
         modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
            el.addEventListener('click', function () {
               closeDsModal(modal);
            });
         });

         modal.querySelectorAll('[data-modal-confirm]').forEach(function (el) {
            el.addEventListener('click', function () {
               closeDsModal(modal);
            });
         });

         modal.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && !modal.hidden) closeDsModal(modal);
         });
      });

      function openDsBottomSheet(sheet) {
         lockPageScroll();
         sheet.hidden = false;
         sheet.classList.remove('ds-bottom-sheet--open');
         requestAnimationFrame(function () {
            requestAnimationFrame(function () {
               sheet.classList.add('ds-bottom-sheet--open');
            });
         });
      }

      function closeDsBottomSheet(sheet) {
         if (!sheet.classList.contains('ds-bottom-sheet--open')) {
            sheet.hidden = true;
            unlockPageScroll();
            return;
         }

         sheet.classList.remove('ds-bottom-sheet--open');
         var panel = sheet.querySelector('.ds-bottom-sheet__panel');
         var finished = false;

         function finish() {
            if (finished) return;
            finished = true;
            sheet.hidden = true;
            unlockPageScroll();
            if (panel) {
               panel.removeEventListener('transitionend', onTransitionEnd);
            }
         }

         function onTransitionEnd(event) {
            if (event.target !== panel) return;
            if (event.propertyName !== 'transform') return;
            finish();
         }

         if (panel) {
            panel.addEventListener('transitionend', onTransitionEnd);
         }
         window.setTimeout(finish, 320);
      }

      document.querySelectorAll('[data-bottom-sheet-open]').forEach(function (trigger) {
         trigger.addEventListener('click', function () {
            var selector = trigger.getAttribute('data-bottom-sheet-open');
            if (!selector) return;
            var sheet = document.querySelector(selector);
            if (sheet) openDsBottomSheet(sheet);
         });
      });

      document.querySelectorAll('.ds-bottom-sheet').forEach(function (sheet) {
         sheet.querySelectorAll('[data-bottom-sheet-close]').forEach(function (el) {
            el.addEventListener('click', function () {
               closeDsBottomSheet(sheet);
            });
         });

         sheet.querySelectorAll('[data-bottom-sheet-confirm]').forEach(function (el) {
            el.addEventListener('click', function () {
               closeDsBottomSheet(sheet);
            });
         });

         sheet.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && !sheet.hidden) closeDsBottomSheet(sheet);
         });
      });

      function syncNavDrawerTriggers(drawer, open) {
         if (!drawer || !drawer.id) return;
         var selector = '#' + drawer.id;
         document.querySelectorAll('[data-nav-drawer-open]').forEach(function (trigger) {
            if (trigger.getAttribute('data-nav-drawer-open') !== selector) return;
            trigger.classList.toggle('ds-nav-drawer-demo__trigger--open', open);
            trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
            trigger.setAttribute('aria-label', open ? 'Fechar menu' : 'Abrir menu');
         });
      }

      function openDsNavDrawer(drawer) {
         lockPageScroll();
         drawer.hidden = false;
         drawer.classList.remove('ds-nav-drawer--open');
         syncNavDrawerTriggers(drawer, true);
         requestAnimationFrame(function () {
            requestAnimationFrame(function () {
               drawer.classList.add('ds-nav-drawer--open');
            });
         });
      }

      function closeDsNavDrawer(drawer) {
         if (!drawer.classList.contains('ds-nav-drawer--open')) {
            drawer.hidden = true;
            unlockPageScroll();
            syncNavDrawerTriggers(drawer, false);
            return;
         }

         drawer.classList.remove('ds-nav-drawer--open');
         syncNavDrawerTriggers(drawer, false);
         var panel = drawer.querySelector('.ds-nav-drawer__panel');
         var finished = false;

         function finish() {
            if (finished) return;
            finished = true;
            drawer.hidden = true;
            unlockPageScroll();
            if (panel) {
               panel.removeEventListener('transitionend', onTransitionEnd);
            }
         }

         function onTransitionEnd(event) {
            if (event.target !== panel) return;
            if (event.propertyName !== 'transform') return;
            finish();
         }

         if (panel) {
            panel.addEventListener('transitionend', onTransitionEnd);
         }
         window.setTimeout(finish, 320);
      }

      document.querySelectorAll('[data-nav-drawer-open]').forEach(function (trigger) {
         trigger.addEventListener('click', function () {
            var selector = trigger.getAttribute('data-nav-drawer-open');
            if (!selector) return;
            var drawer = document.querySelector(selector);
            if (!drawer) return;
            if (!drawer.hidden && drawer.classList.contains('ds-nav-drawer--open')) {
               closeDsNavDrawer(drawer);
               return;
            }
            openDsNavDrawer(drawer);
         });
      });

      document.querySelectorAll('.ds-nav-drawer').forEach(function (drawer) {
         drawer.querySelectorAll('[data-nav-drawer-close]').forEach(function (el) {
            el.addEventListener('click', function () {
               closeDsNavDrawer(drawer);
            });
         });

         drawer.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && !drawer.hidden) closeDsNavDrawer(drawer);
         });
      });
   })();

   (function initDsAccordions() {
      function setAccordionItemState(item, open) {
         var trigger = item.querySelector('.ds-accordion__trigger');
         var panelId = trigger && trigger.getAttribute('aria-controls');
         var panel = panelId ? document.getElementById(panelId) : item.querySelector('.ds-accordion__panel');
         item.classList.toggle('ds-accordion__item--open', open);
         if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
         if (panel) panel.hidden = !open;
      }

      document.querySelectorAll('[data-accordion]').forEach(function (accordion) {
         var single = accordion.hasAttribute('data-accordion-single');

         accordion.querySelectorAll('.ds-accordion__item').forEach(function (item) {
            var isOpen = item.classList.contains('ds-accordion__item--open');
            setAccordionItemState(item, isOpen);
         });

         accordion.querySelectorAll('.ds-accordion__trigger').forEach(function (trigger) {
            trigger.addEventListener('click', function () {
               var item = trigger.closest('.ds-accordion__item');
               if (!item) return;
               var willOpen = !item.classList.contains('ds-accordion__item--open');

               if (single && willOpen) {
                  accordion.querySelectorAll('.ds-accordion__item--open').forEach(function (openItem) {
                     if (openItem !== item) setAccordionItemState(openItem, false);
                  });
               }

               setAccordionItemState(item, willOpen);
            });
         });
      });
   })();

   (function initAdvancedFilterInline() {
      document.querySelectorAll('[data-advanced-filter-inline]').forEach(function (root) {
         var header = root.querySelector('.ds-advanced-filter__header');
         var panel = root.querySelector('.ds-advanced-filter__panel');
         if (!header || !panel) return;

         function setOpen(open) {
            root.classList.toggle('ds-advanced-filter--open', open);
            header.setAttribute('aria-expanded', open ? 'true' : 'false');
            panel.setAttribute('aria-hidden', open ? 'false' : 'true');
         }

         setOpen(false);

         header.addEventListener('click', function () {
            setOpen(!root.classList.contains('ds-advanced-filter--open'));
         });
      });
   })();

   (function initDsFeedbackRatings() {
      document.querySelectorAll('[data-feedback-rating]').forEach(function (root) {
         var buttons = root.querySelectorAll('[data-feedback-value]');

         buttons.forEach(function (btn) {
            btn.setAttribute('aria-pressed', 'false');

            btn.addEventListener('click', function () {
               var value = btn.getAttribute('data-feedback-value');
               var isSelected = btn.classList.contains('ds-feedback-rating__btn--selected');

               buttons.forEach(function (other) {
                  other.classList.remove('ds-feedback-rating__btn--selected');
                  other.setAttribute('aria-pressed', 'false');
               });

               if (!isSelected) {
                  btn.classList.add('ds-feedback-rating__btn--selected');
                  btn.setAttribute('aria-pressed', 'true');
                  root.dispatchEvent(
                     new CustomEvent('feedback-rating-change', {
                        bubbles: true,
                        detail: { value: value },
                     })
                  );
               }
            });
         });
      });
   })();

   (function initMobileToasts() {
      function hideToast(toast) {
         if (!toast) return;
         var host = toast.closest ? toast.closest('.ds-m-toast-host') : null;
         toast.classList.remove('ds-m-toast--visible');
         window.clearTimeout(toast._hideTimer);
         if (host && !host.querySelector('.ds-m-toast--visible')) {
            host.classList.remove('ds-m-toast-host--visible');
         }
         toast._hideTimer = window.setTimeout(function () {
            toast.setAttribute('hidden', '');
         }, 280);
      }

      function showToast(toast) {
         if (!toast) return;
         var host = toast.closest ? toast.closest('.ds-m-toast-host') : null;
         if (host) {
            host.classList.add('ds-m-toast-host--visible');
         }
         toast.removeAttribute('hidden');
         requestAnimationFrame(function () {
            toast.classList.add('ds-m-toast--visible');
         });
         window.clearTimeout(toast._hideTimer);
         var duration = parseInt(toast.getAttribute('data-duration') || '4000', 10);
         toast._hideTimer = window.setTimeout(function () {
            hideToast(toast);
         }, duration);
      }

      document.querySelectorAll('[data-mobile-toast-trigger]').forEach(function (btn) {
         btn.addEventListener('click', function () {
            var id = btn.getAttribute('data-mobile-toast-trigger');
            showToast(id ? document.getElementById(id) : null);
         });
      });

      document.querySelectorAll('[data-mobile-toast-close]').forEach(function (btn) {
         btn.addEventListener('click', function () {
            hideToast(btn.closest('.ds-m-toast'));
         });
      });
   })();

   document.querySelectorAll('.ds-download-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
         var container = btn.closest('.ds-brand-box, .ds-icon-card, .ds-loader-card');
         var svg = container && container.querySelector('.ds-brand-box__preview svg, .ds-icon-card__preview svg, .ds-loader-card__preview svg');
         if (!svg) return;

         var filename =
            (container && (container.getAttribute('data-logo-file') || container.getAttribute('data-icon-file') || container.getAttribute('data-asset-file'))) ||
            'asset-alfa.svg';
         var blob = new Blob([formatSvg(svg)], { type: 'image/svg+xml;charset=utf-8' });
         var url = URL.createObjectURL(blob);
         var link = document.createElement('a');
         link.href = url;
         link.download = filename;
         link.click();
         URL.revokeObjectURL(url);

         setActionFeedback(btn, btn.getAttribute('data-tooltip-success') || 'Baixado!', 'is-done');
      });
   });
})();
